// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../packages/ui-components/src/styles/specra-fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../packages/ui-components/src/styles/specra-tokens.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../packages/ui-components/src/styles/specra-behaviors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.10 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: var(--font-text); /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: IBM Plex Mono, ui-monospace, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

:root {
    --chart-1: 12 76% 61%;
    --chart-2: 173 58% 39%;
    --chart-3: 197 37% 24%;
    --chart-4: 43 74% 66%;
    --chart-5: 27 87% 67%;
    --sidebar-background: 0 0% 98%;
    --sidebar-foreground: 240 5.3% 26.1%;
    --sidebar-primary: 240 5.9% 10%;
    --sidebar-primary-foreground: 0 0% 98%;
    --sidebar-accent: 240 4.8% 95.9%;
    --sidebar-accent-foreground: 240 5.9% 10%;
    --sidebar-border: 220 13% 91%;
    --sidebar-ring: 217.2 91.2% 59.8%;
    /* Block overlay colors for document visualization */
    --block-color-heading: #3b82f6;
    --block-color-content: #6b7280;
    --block-color-table: #10b981;
    --block-color-list: #f59e0b;
    --block-color-image: #8b5cf6;
    --block-color-footer: #ef4444;
    /* Transparent variants for hover (20% opacity) and selection (40% opacity) */
    --block-color-heading-20: rgba(59, 130, 246, 0.2);
    --block-color-heading-40: rgba(59, 130, 246, 0.4);
    --block-color-content-20: rgba(107, 114, 128, 0.2);
    --block-color-content-40: rgba(107, 114, 128, 0.4);
    --block-color-table-20: rgba(16, 185, 129, 0.2);
    --block-color-table-40: rgba(16, 185, 129, 0.4);
    --block-color-list-20: rgba(245, 158, 11, 0.2);
    --block-color-list-40: rgba(245, 158, 11, 0.4);
    --block-color-image-20: rgba(139, 92, 246, 0.2);
    --block-color-image-40: rgba(139, 92, 246, 0.4);
    --block-color-footer-20: rgba(239, 68, 68, 0.2);
    --block-color-footer-40: rgba(239, 68, 68, 0.4);

    /* Project type colors */
    --project-type-proposal: 221 83% 53%;
    --project-type-proposal-foreground: 0 0% 100%;
    --project-type-general: 162 63% 41%;
    --project-type-general-foreground: 0 0% 100%;
  }

.dark {
    --chart-1: 220 70% 50%;
    --chart-2: 160 60% 45%;
    --chart-3: 30 80% 55%;
    --chart-4: 280 65% 60%;
    --chart-5: 340 75% 55%;
    --sidebar-background: 240 5.9% 10%;
    --sidebar-foreground: 240 4.8% 95.9%;
    --sidebar-primary: 224.3 76.3% 48%;
    --sidebar-primary-foreground: 0 0% 100%;
    --sidebar-accent: 240 3.7% 15.9%;
    --sidebar-accent-foreground: 240 4.8% 95.9%;
    --sidebar-border: 240 3.7% 15.9%;
    --sidebar-ring: 217.2 91.2% 59.8%;

    /* Block overlay colors for document visualization - lighter for dark mode */
    --block-color-heading: #60a5fa;
    --block-color-content: #9ca3af;
    --block-color-table: #34d399;
    --block-color-list: #fbbf24;
    --block-color-image: #a78bfa;
    --block-color-footer: #f87171;
    /* Transparent variants for hover (20% opacity) and selection (40% opacity) */
    --block-color-heading-20: rgba(96, 165, 250, 0.2);
    --block-color-heading-40: rgba(96, 165, 250, 0.4);
    --block-color-content-20: rgba(156, 163, 175, 0.2);
    --block-color-content-40: rgba(156, 163, 175, 0.4);
    --block-color-table-20: rgba(52, 211, 153, 0.2);
    --block-color-table-40: rgba(52, 211, 153, 0.4);
    --block-color-list-20: rgba(251, 191, 36, 0.2);
    --block-color-list-40: rgba(251, 191, 36, 0.4);
    --block-color-image-20: rgba(167, 139, 250, 0.2);
    --block-color-image-40: rgba(167, 139, 250, 0.4);
    --block-color-footer-20: rgba(248, 113, 113, 0.2);
    --block-color-footer-40: rgba(248, 113, 113, 0.4);

    /* Project type colors - lighter for dark mode */
    --project-type-proposal: 217 91% 60%;
    --project-type-proposal-foreground: 0 0% 100%;
    --project-type-general: 160 84% 39%;
    --project-type-general-foreground: 0 0% 100%;
  }

*{
  border-color: hsl(var(--border));
}

/* The shell is one fixed viewport and content scrolls inside it, so the
     window itself never scrolls. Without this, a trackpad swipe over a part
     that cannot scroll (or past the end of one that can) rubber-bands the
     whole window on macOS and shows blank space under the app. Vertical
     only: a sideways swipe stays back/forward navigation. */

html,
  body {
    overscroll-behavior-y: none;
  }

body{
  background-color: hsl(var(--background));
  font-family: var(--font-text);
  color: hsl(var(--foreground));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: var(--font-display);
    letter-spacing: var(--ls-display);
  }

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.\\!container{
  width: 100% !important;
  margin-right: auto !important;
  margin-left: auto !important;
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.container{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 2rem;
  padding-left: 2rem;
}
@media (min-width: 1400px){

  .\\!container{
    max-width: 1400px !important;
  }

  .container{
    max-width: 1400px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.\\!visible{
  visibility: visible !important;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.inset-y-\\[var\\(--component-schedule-marker-bleed\\)\\]{
  top: var(--component-schedule-marker-bleed);
  bottom: var(--component-schedule-marker-bleed);
}
.-bottom-5{
  bottom: -1.25rem;
}
.-left-1{
  left: -0.25rem;
}
.-left-\\[21px\\]{
  left: -21px;
}
.-left-\\[31px\\]{
  left: -31px;
}
.-right-0\\.5{
  right: -0.125rem;
}
.-right-1{
  right: -0.25rem;
}
.-top-0\\.5{
  top: -0.125rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-6{
  top: -1.5rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-1{
  bottom: 0.25rem;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-3{
  bottom: 0.75rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-5{
  bottom: 1.25rem;
}
.bottom-8{
  bottom: 2rem;
}
.bottom-\\[var\\(--space-1\\)\\]{
  bottom: var(--space-1);
}
.bottom-\\[var\\(--space-5\\)\\]{
  bottom: var(--space-5);
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-\\[11px\\]{
  left: 11px;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.left-\\[var\\(--component-chart-label-width\\)\\]{
  left: var(--component-chart-label-width);
}
.left-full{
  left: 100%;
}
.right-0{
  right: 0px;
}
.right-0\\.5{
  right: 0.125rem;
}
.right-1{
  right: 0.25rem;
}
.right-10{
  right: 2.5rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-\\[var\\(--space-1\\)\\]{
  right: var(--space-1);
}
.right-full{
  right: 100%;
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 0.125rem;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-12{
  top: 3rem;
}
.top-2{
  top: 0.5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-6{
  top: 1.5rem;
}
.top-7{
  top: 1.75rem;
}
.top-8{
  top: 2rem;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[var\\(--component-command-top-mobile\\)\\]{
  top: var(--component-command-top-mobile);
}
.top-\\[var\\(--component-swimlane-header-height\\)\\]{
  top: var(--component-swimlane-header-height);
}
.top-\\[var\\(--space-0-5\\)\\]{
  top: var(--space-0-5);
}
.top-\\[var\\(--space-1\\)\\]{
  top: var(--space-1);
}
.top-\\[var\\(--space-6\\)\\]{
  top: var(--space-6);
}
.top-full{
  top: 100%;
}
.isolate{
  isolation: isolate;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[1000\\]{
  z-index: 1000;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[101\\]{
  z-index: 101;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[45\\]{
  z-index: 45;
}
.z-\\[60\\]{
  z-index: 60;
}
.order-3{
  order: 3;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-start-2{
  grid-column-start: 2;
}
.col-start-3{
  grid-column-start: 3;
}
.row-start-1{
  grid-row-start: 1;
}
.-m-1\\.5{
  margin: -0.375rem;
}
.m-0{
  margin: 0px;
}
.m-1{
  margin: 0.25rem;
}
.m-2{
  margin: 0.5rem;
}
.m-3{
  margin: 0.75rem;
}
.m-\\[var\\(--space-2\\)\\]{
  margin: var(--space-2);
}
.m-\\[var\\(--space-4\\)\\]{
  margin: var(--space-4);
}
.m-\\[var\\(--space-6\\)\\]{
  margin: var(--space-6);
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2{
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.-mx-6{
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.mx-0\\.5{
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3\\.5{
  margin-left: 0.875rem;
  margin-right: 0.875rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.mx-px{
  margin-left: 1px;
  margin-right: 1px;
}
.my-0\\.5{
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.-mb-3{
  margin-bottom: -0.75rem;
}
.-mb-6{
  margin-bottom: -1.5rem;
}
.-mb-px{
  margin-bottom: -1px;
}
.-ml-1{
  margin-left: -0.25rem;
}
.-ml-2{
  margin-left: -0.5rem;
}
.-mr-2{
  margin-right: -0.5rem;
}
.-mr-\\[var\\(--space-0-5\\)\\]{
  margin-right: calc(var(--space-0-5) * -1);
}
.-mt-2{
  margin-top: -0.5rem;
}
.-mt-3{
  margin-top: -0.75rem;
}
.-mt-6{
  margin-top: -1.5rem;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-3\\.5{
  margin-bottom: 0.875rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[18px\\]{
  margin-bottom: 18px;
}
.mb-\\[var\\(--space-0-5\\)\\]{
  margin-bottom: var(--space-0-5);
}
.mb-\\[var\\(--space-1\\)\\]{
  margin-bottom: var(--space-1);
}
.mb-\\[var\\(--space-2\\)\\]{
  margin-bottom: var(--space-2);
}
.mb-\\[var\\(--space-2-5\\)\\]{
  margin-bottom: var(--space-2-5);
}
.mb-\\[var\\(--space-3\\)\\]{
  margin-bottom: var(--space-3);
}
.mb-\\[var\\(--space-3-5\\)\\]{
  margin-bottom: var(--space-3-5);
}
.mb-\\[var\\(--space-4\\)\\]{
  margin-bottom: var(--space-4);
}
.mb-\\[var\\(--space-5-5\\)\\]{
  margin-bottom: var(--space-5-5);
}
.mb-\\[var\\(--space-card\\)\\]{
  margin-bottom: var(--space-card);
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-9{
  margin-left: 2.25rem;
}
.ml-\\[38px\\]{
  margin-left: 38px;
}
.ml-\\[var\\(--component-risk-axis-indent\\)\\]{
  margin-left: var(--component-risk-axis-indent);
}
.ml-\\[var\\(--space-1\\)\\]{
  margin-left: var(--space-1);
}
.ml-\\[var\\(--space-1-5\\)\\]{
  margin-left: var(--space-1-5);
}
.ml-\\[var\\(--space-3\\)\\]{
  margin-left: var(--space-3);
}
.ml-auto{
  margin-left: auto;
}
.mr-0\\.5{
  margin-right: 0.125rem;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-\\[var\\(--space-1\\)\\]{
  margin-right: var(--space-1);
}
.mr-auto{
  margin-right: auto;
}
.ms-1{
  margin-inline-start: 0.25rem;
}
.ms-2{
  margin-inline-start: 0.5rem;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-3\\.5{
  margin-top: 0.875rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[22px\\]{
  margin-top: 22px;
}
.mt-\\[3px\\]{
  margin-top: 3px;
}
.mt-\\[5px\\]{
  margin-top: 5px;
}
.mt-\\[var\\(--space-0-5\\)\\]{
  margin-top: var(--space-0-5);
}
.mt-\\[var\\(--space-1\\)\\]{
  margin-top: var(--space-1);
}
.mt-\\[var\\(--space-1-5\\)\\]{
  margin-top: var(--space-1-5);
}
.mt-\\[var\\(--space-2\\)\\]{
  margin-top: var(--space-2);
}
.mt-\\[var\\(--space-2-5\\)\\]{
  margin-top: var(--space-2-5);
}
.mt-\\[var\\(--space-3\\)\\]{
  margin-top: var(--space-3);
}
.mt-\\[var\\(--space-3-5\\)\\]{
  margin-top: var(--space-3-5);
}
.mt-\\[var\\(--space-4\\)\\]{
  margin-top: var(--space-4);
}
.mt-\\[var\\(--space-5-5\\)\\]{
  margin-top: var(--space-5-5);
}
.mt-\\[var\\(--space-6\\)\\]{
  margin-top: var(--space-6);
}
.mt-\\[var\\(--space-ui-gap\\)\\]{
  margin-top: var(--space-ui-gap);
}
.mt-auto{
  margin-top: auto;
}
.mt-px{
  margin-top: 1px;
}
.box-content{
  box-sizing: content-box;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.line-clamp-4{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.\\!inline{
  display: inline !important;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.\\!table{
  display: table !important;
}
.table{
  display: table;
}
.table-cell{
  display: table-cell;
}
.grid{
  display: grid;
}
.\\!contents{
  display: contents !important;
}
.contents{
  display: contents;
}
.\\!hidden{
  display: none !important;
}
.hidden{
  display: none;
}
.aspect-\\[2\\/1\\]{
  aspect-ratio: 2/1;
}
.aspect-\\[3\\/4\\]{
  aspect-ratio: 3/4;
}
.aspect-\\[4\\/3\\]{
  aspect-ratio: 4/3;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.size-1{
  width: 0.25rem;
  height: 0.25rem;
}
.size-1\\.5{
  width: 0.375rem;
  height: 0.375rem;
}
.size-12{
  width: 3rem;
  height: 3rem;
}
.size-2{
  width: 0.5rem;
  height: 0.5rem;
}
.size-2\\.5{
  width: 0.625rem;
  height: 0.625rem;
}
.size-3{
  width: 0.75rem;
  height: 0.75rem;
}
.size-3\\.5{
  width: 0.875rem;
  height: 0.875rem;
}
.size-4{
  width: 1rem;
  height: 1rem;
}
.size-5{
  width: 1.25rem;
  height: 1.25rem;
}
.size-6{
  width: 1.5rem;
  height: 1.5rem;
}
.size-7{
  width: 1.75rem;
  height: 1.75rem;
}
.size-8{
  width: 2rem;
  height: 2rem;
}
.size-\\[var\\(--avatar-lg\\)\\]{
  width: var(--avatar-lg);
  height: var(--avatar-lg);
}
.size-\\[var\\(--avatar-md\\)\\]{
  width: var(--avatar-md);
  height: var(--avatar-md);
}
.size-\\[var\\(--avatar-sm\\)\\]{
  width: var(--avatar-sm);
  height: var(--avatar-sm);
}
.size-\\[var\\(--component-chart-dot\\)\\]{
  width: var(--component-chart-dot);
  height: var(--component-chart-dot);
}
.size-\\[var\\(--component-chart-marker\\)\\]{
  width: var(--component-chart-marker);
  height: var(--component-chart-marker);
}
.size-\\[var\\(--component-chart-swatch\\)\\]{
  width: var(--component-chart-swatch);
  height: var(--component-chart-swatch);
}
.size-\\[var\\(--component-numbered-nav-size\\)\\]{
  width: var(--component-numbered-nav-size);
  height: var(--component-numbered-nav-size);
}
.size-\\[var\\(--control-height-lg\\)\\]{
  width: var(--control-height-lg);
  height: var(--control-height-lg);
}
.size-\\[var\\(--control-height-md\\)\\]{
  width: var(--control-height-md);
  height: var(--control-height-md);
}
.size-\\[var\\(--control-height-sm\\)\\]{
  width: var(--control-height-sm);
  height: var(--control-height-sm);
}
.size-\\[var\\(--icon-tile-lg\\)\\]{
  width: var(--icon-tile-lg);
  height: var(--icon-tile-lg);
}
.size-\\[var\\(--icon-tile-md\\)\\]{
  width: var(--icon-tile-md);
  height: var(--icon-tile-md);
}
.size-\\[var\\(--icon-tile-sm\\)\\]{
  width: var(--icon-tile-sm);
  height: var(--icon-tile-sm);
}
.size-\\[var\\(--switch-thumb\\)\\]{
  width: var(--switch-thumb);
  height: var(--switch-thumb);
}
.size-full{
  width: 100%;
  height: 100%;
}
.size-px{
  width: 1px;
  height: 1px;
}
.\\!h-2{
  height: 0.5rem !important;
}
.h-0{
  height: 0px;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-44{
  height: 11rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[13px\\]{
  height: 13px;
}
.h-\\[180px\\]{
  height: 180px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[257px\\]{
  height: 257px;
}
.h-\\[26px\\]{
  height: 26px;
}
.h-\\[3px\\]{
  height: 3px;
}
.h-\\[440px\\]{
  height: 440px;
}
.h-\\[460px\\]{
  height: 460px;
}
.h-\\[520px\\]{
  height: 520px;
}
.h-\\[560px\\]{
  height: 560px;
}
.h-\\[60vh\\]{
  height: 60vh;
}
.h-\\[640px\\]{
  height: 640px;
}
.h-\\[70vh\\]{
  height: 70vh;
}
.h-\\[85vh\\]{
  height: 85vh;
}
.h-\\[calc\\(100vh-220px\\)\\]{
  height: calc(100vh - 220px);
}
.h-\\[calc\\(85vh-120px\\)\\]{
  height: calc(85vh - 120px);
}
.h-\\[var\\(--component-calendar-day-height\\)\\]{
  height: var(--component-calendar-day-height);
}
.h-\\[var\\(--component-chart-bar-height\\)\\]{
  height: var(--component-chart-bar-height);
}
.h-\\[var\\(--component-chart-heat-cell-height\\)\\]{
  height: var(--component-chart-heat-cell-height);
}
.h-\\[var\\(--component-chart-plot-height\\)\\]{
  height: var(--component-chart-plot-height);
}
.h-\\[var\\(--component-chart-strip-height\\)\\]{
  height: var(--component-chart-strip-height);
}
.h-\\[var\\(--component-dot-plot-row-height\\)\\]{
  height: var(--component-dot-plot-row-height);
}
.h-\\[var\\(--component-org-card-height\\)\\]{
  height: var(--component-org-card-height);
}
.h-\\[var\\(--component-progress-track-height\\)\\]{
  height: var(--component-progress-track-height);
}
.h-\\[var\\(--component-progress-track-height-thin\\)\\]{
  height: var(--component-progress-track-height-thin);
}
.h-\\[var\\(--component-risk-cell-height\\)\\]{
  height: var(--component-risk-cell-height);
}
.h-\\[var\\(--component-swimlane-band-height\\)\\]{
  height: var(--component-swimlane-band-height);
}
.h-\\[var\\(--component-swimlane-header-height\\)\\]{
  height: var(--component-swimlane-header-height);
}
.h-\\[var\\(--component-swimlane-lane-height\\)\\]{
  height: var(--component-swimlane-lane-height);
}
.h-\\[var\\(--component-swimlane-lane-height-compact\\)\\]{
  height: var(--component-swimlane-lane-height-compact);
}
.h-\\[var\\(--component-swimlane-segment-height\\)\\]{
  height: var(--component-swimlane-segment-height);
}
.h-\\[var\\(--component-topbar-height\\)\\]{
  height: var(--component-topbar-height);
}
.h-\\[var\\(--control-height-lg\\)\\]{
  height: var(--control-height-lg);
}
.h-\\[var\\(--control-height-md\\)\\]{
  height: var(--control-height-md);
}
.h-\\[var\\(--control-height-sm\\)\\]{
  height: var(--control-height-sm);
}
.h-\\[var\\(--control-height-tab\\)\\]{
  height: var(--control-height-tab);
}
.h-\\[var\\(--control-height-xs\\)\\]{
  height: var(--control-height-xs);
}
.h-\\[var\\(--fs-h3\\)\\]{
  height: var(--fs-h3);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-\\[var\\(--space-1\\)\\]{
  height: var(--space-1);
}
.h-\\[var\\(--space-4\\)\\]{
  height: var(--space-4);
}
.h-\\[var\\(--space-6\\)\\]{
  height: var(--space-6);
}
.h-\\[var\\(--switch-height\\)\\]{
  height: var(--switch-height);
}
.h-auto{
  height: auto;
}
.h-dvh{
  height: 100dvh;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-16{
  max-height: 4rem;
}
.max-h-32{
  max-height: 8rem;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-80{
  max-height: 20rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[40vh\\]{
  max-height: 40vh;
}
.max-h-\\[60vh\\]{
  max-height: 60vh;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[calc\\(100dvh-var\\(--component-overlay-edge-gap\\)\\)\\]{
  max-height: calc(100dvh - var(--component-overlay-edge-gap));
}
.max-h-\\[var\\(--component-chart-table-max-height\\)\\]{
  max-height: var(--component-chart-table-max-height);
}
.max-h-\\[var\\(--component-command-results-max-height\\)\\]{
  max-height: var(--component-command-results-max-height);
}
.max-h-\\[var\\(--component-overlay-list-max-height\\)\\]{
  max-height: var(--component-overlay-list-max-height);
}
.max-h-\\[var\\(--component-sidebar-mobile-max-height\\)\\]{
  max-height: var(--component-sidebar-mobile-max-height);
}
.max-h-\\[var\\(--component-workroom-mobile-max-height\\)\\]{
  max-height: var(--component-workroom-mobile-max-height);
}
.max-h-full{
  max-height: 100%;
}
.min-h-0{
  min-height: 0px;
}
.min-h-12{
  min-height: 3rem;
}
.min-h-14{
  min-height: 3.5rem;
}
.min-h-40{
  min-height: 10rem;
}
.min-h-8{
  min-height: 2rem;
}
.min-h-96{
  min-height: 24rem;
}
.min-h-\\[2\\.25rem\\]{
  min-height: 2.25rem;
}
.min-h-\\[2em\\]{
  min-height: 2em;
}
.min-h-\\[3\\.5rem\\]{
  min-height: 3.5rem;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[400px\\]{
  min-height: 400px;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[40vh\\]{
  min-height: 40vh;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[60vh\\]{
  min-height: 60vh;
}
.min-h-\\[720px\\]{
  min-height: 720px;
}
.min-h-\\[800px\\]{
  min-height: 800px;
}
.min-h-\\[var\\(--component-document-host-min-height\\)\\]{
  min-height: var(--component-document-host-min-height);
}
.min-h-\\[var\\(--component-master-detail-min-height\\)\\]{
  min-height: var(--component-master-detail-min-height);
}
.min-h-\\[var\\(--component-overlay-list-max-height\\)\\]{
  min-height: var(--component-overlay-list-max-height);
}
.min-h-\\[var\\(--component-topbar-height\\)\\]{
  min-height: var(--component-topbar-height);
}
.min-h-\\[var\\(--space-20\\)\\]{
  min-height: var(--space-20);
}
.min-h-dvh{
  min-height: 100dvh;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.\\!w-2{
  width: 0.5rem !important;
}
.w-0{
  width: 0px;
}
.w-0\\.5{
  width: 0.125rem;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-2\\/5{
  width: 40%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/5{
  width: 80%;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-5\\/6{
  width: 83.333333%;
}
.w-52{
  width: 13rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[--radix-popper-anchor-width\\]{
  width: var(--radix-popper-anchor-width);
}
.w-\\[104px\\]{
  width: 104px;
}
.w-\\[128px\\]{
  width: 128px;
}
.w-\\[13px\\]{
  width: 13px;
}
.w-\\[140px\\]{
  width: 140px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[160px\\]{
  width: 160px;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[22px\\]{
  width: 22px;
}
.w-\\[260px\\]{
  width: 260px;
}
.w-\\[26px\\]{
  width: 26px;
}
.w-\\[320px\\]{
  width: 320px;
}
.w-\\[350px\\]{
  width: 350px;
}
.w-\\[520px\\]{
  width: 520px;
}
.w-\\[560px\\]{
  width: 560px;
}
.w-\\[680px\\]{
  width: 680px;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[90px\\]{
  width: 90px;
}
.w-\\[92vw\\]{
  width: 92vw;
}
.w-\\[95vw\\]{
  width: 95vw;
}
.w-\\[calc\\(100\\%-var\\(--component-overlay-edge-gap\\)\\)\\]{
  width: calc(100% - var(--component-overlay-edge-gap));
}
.w-\\[calc\\(100vw-2rem\\)\\]{
  width: calc(100vw - 2rem);
}
.w-\\[calc\\(var\\(--space-12\\)\\*2\\)\\]{
  width: calc(var(--space-12) * 2);
}
.w-\\[min\\(24rem\\2c 80vw\\)\\]{
  width: min(24rem,80vw);
}
.w-\\[var\\(--component-attention-badge-width\\)\\]{
  width: var(--component-attention-badge-width);
}
.w-\\[var\\(--component-briefing-rail-width\\)\\]{
  width: var(--component-briefing-rail-width);
}
.w-\\[var\\(--component-chart-label-width\\)\\]{
  width: var(--component-chart-label-width);
}
.w-\\[var\\(--component-flow-label-width\\)\\]{
  width: var(--component-flow-label-width);
}
.w-\\[var\\(--component-flow-node-width\\)\\]{
  width: var(--component-flow-node-width);
}
.w-\\[var\\(--component-guide-card-width\\)\\]{
  width: var(--component-guide-card-width);
}
.w-\\[var\\(--component-org-card-width\\)\\]{
  width: var(--component-org-card-width);
}
.w-\\[var\\(--component-swimlane-label-width\\)\\]{
  width: var(--component-swimlane-label-width);
}
.w-\\[var\\(--radix-popover-anchor-width\\)\\]{
  width: var(--radix-popover-anchor-width);
}
.w-\\[var\\(--radix-popover-trigger-width\\)\\]{
  width: var(--radix-popover-trigger-width);
}
.w-\\[var\\(--space-2\\)\\]{
  width: var(--space-2);
}
.w-\\[var\\(--space-3-5\\)\\]{
  width: var(--space-3-5);
}
.w-\\[var\\(--switch-width\\)\\]{
  width: var(--switch-width);
}
.w-auto{
  width: auto;
}
.w-fit{
  width: -moz-fit-content;
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-px{
  width: 1px;
}
.w-screen{
  width: 100vw;
}
.min-w-0{
  min-width: 0px;
}
.min-w-32{
  min-width: 8rem;
}
.min-w-36{
  min-width: 9rem;
}
.min-w-4{
  min-width: 1rem;
}
.min-w-40{
  min-width: 10rem;
}
.min-w-44{
  min-width: 11rem;
}
.min-w-48{
  min-width: 12rem;
}
.min-w-52{
  min-width: 13rem;
}
.min-w-56{
  min-width: 14rem;
}
.min-w-64{
  min-width: 16rem;
}
.min-w-\\[1200px\\]{
  min-width: 1200px;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[18px\\]{
  min-width: 18px;
}
.min-w-\\[18rem\\]{
  min-width: 18rem;
}
.min-w-\\[2\\.75rem\\]{
  min-width: 2.75rem;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[250px\\]{
  min-width: 250px;
}
.min-w-\\[320px\\]{
  min-width: 320px;
}
.min-w-\\[360px\\]{
  min-width: 360px;
}
.min-w-\\[44px\\]{
  min-width: 44px;
}
.min-w-\\[56px\\]{
  min-width: 56px;
}
.min-w-\\[600px\\]{
  min-width: 600px;
}
.min-w-\\[60px\\]{
  min-width: 60px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[90px\\]{
  min-width: 90px;
}
.min-w-\\[calc\\(var\\(--component-chart-label-width\\)\\*2\\.5\\)\\]{
  min-width: calc(var(--component-chart-label-width) * 2.5);
}
.min-w-\\[calc\\(var\\(--component-flow-label-width\\)\\*4\\)\\]{
  min-width: calc(var(--component-flow-label-width) * 4);
}
.min-w-\\[var\\(--component-agenda-min-width\\)\\]{
  min-width: var(--component-agenda-min-width);
}
.min-w-\\[var\\(--component-data-table-min-width\\)\\]{
  min-width: var(--component-data-table-min-width);
}
.min-w-\\[var\\(--component-gantt-min-width\\)\\]{
  min-width: var(--component-gantt-min-width);
}
.min-w-\\[var\\(--component-swimlane-min-width\\)\\]{
  min-width: var(--component-swimlane-min-width);
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.min-w-\\[var\\(--space-0-5\\)\\]{
  min-width: var(--space-0-5);
}
.min-w-full{
  min-width: 100%;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-56{
  max-width: 14rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-60{
  max-width: 15rem;
}
.max-w-64{
  max-width: 16rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-72{
  max-width: 18rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-80{
  max-width: 20rem;
}
.max-w-96{
  max-width: 24rem;
}
.max-w-\\[100px\\]{
  max-width: 100px;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[1400px\\]{
  max-width: 1400px;
}
.max-w-\\[14rem\\]{
  max-width: 14rem;
}
.max-w-\\[150px\\]{
  max-width: 150px;
}
.max-w-\\[1600px\\]{
  max-width: 1600px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[18rem\\]{
  max-width: 18rem;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[240px\\]{
  max-width: 240px;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[28ch\\]{
  max-width: 28ch;
}
.max-w-\\[420px\\]{
  max-width: 420px;
}
.max-w-\\[44ch\\]{
  max-width: 44ch;
}
.max-w-\\[46ch\\]{
  max-width: 46ch;
}
.max-w-\\[480px\\]{
  max-width: 480px;
}
.max-w-\\[520px\\]{
  max-width: 520px;
}
.max-w-\\[600px\\]{
  max-width: 600px;
}
.max-w-\\[62ch\\]{
  max-width: 62ch;
}
.max-w-\\[640px\\]{
  max-width: 640px;
}
.max-w-\\[720px\\]{
  max-width: 720px;
}
.max-w-\\[760px\\]{
  max-width: 760px;
}
.max-w-\\[860px\\]{
  max-width: 860px;
}
.max-w-\\[960px\\]{
  max-width: 960px;
}
.max-w-\\[calc\\(100vw-2rem\\)\\]{
  max-width: calc(100vw - 2rem);
}
.max-w-\\[calc\\(100vw-var\\(--component-overlay-edge-gap\\)\\)\\]{
  max-width: calc(100vw - var(--component-overlay-edge-gap));
}
.max-w-\\[calc\\(100vw-var\\(--space-8\\)\\)\\]{
  max-width: calc(100vw - var(--space-8));
}
.max-w-\\[min\\(60vw\\2c 40rem\\)\\]{
  max-width: min(60vw,40rem);
}
.max-w-\\[var\\(--component-chart-column-max-width\\)\\]{
  max-width: var(--component-chart-column-max-width);
}
.max-w-\\[var\\(--component-editor-side-width\\)\\]{
  max-width: var(--component-editor-side-width);
}
.max-w-\\[var\\(--component-overlay-actions-max-width\\)\\]{
  max-width: var(--component-overlay-actions-max-width);
}
.max-w-\\[var\\(--component-progress-compact-width\\)\\]{
  max-width: var(--component-progress-compact-width);
}
.max-w-\\[var\\(--component-risk-matrix-width\\)\\]{
  max-width: var(--component-risk-matrix-width);
}
.max-w-\\[var\\(--component-swimlane-label-width\\)\\]{
  max-width: var(--component-swimlane-label-width);
}
.max-w-\\[var\\(--component-swimlane-min-width\\)\\]{
  max-width: var(--component-swimlane-min-width);
}
.max-w-\\[var\\(--component-work-column-width\\)\\]{
  max-width: var(--component-work-column-width);
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1 0%;
}
.flex-\\[2\\]{
  flex: 2;
}
.flex-\\[3\\]{
  flex: 3;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.basis-0{
  flex-basis: 0px;
}
.basis-2\\/5{
  flex-basis: 40%;
}
.basis-full{
  flex-basis: 100%;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-bottom-left{
  transform-origin: bottom left;
}
.origin-bottom-right{
  transform-origin: bottom right;
}
.origin-top-left{
  transform-origin: top left;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-full{
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2{
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6{
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-45{
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-125{
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75{
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.15\\]{
  --tw-scale-x: 0.15;
  --tw-scale-y: 0.15;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes fade-in{

  from{
    opacity: 0;
    transform: translateY(4px);
  }

  to{
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fade-in{
  animation: fade-in 0.2s ease-out;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes shimmer{

  0%{
    background-position: -200% 0;
  }

  100%{
    background-position: 200% 0;
  }
}
.animate-shimmer{
  animation: shimmer 1.5s ease-in-out infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-col-resize{
  cursor: col-resize;
}
.cursor-default{
  cursor: default;
}
.cursor-grab{
  cursor: grab;
}
.cursor-help{
  cursor: help;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-text{
  cursor: text;
}
.cursor-zoom-in{
  cursor: zoom-in;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.select-all{
  -webkit-user-select: all;
     -moz-user-select: all;
          user-select: all;
}
.resize-none{
  resize: none;
}
.resize-y{
  resize: vertical;
}
.resize{
  resize: both;
}
.scroll-mt-4{
  scroll-margin-top: 1rem;
}
.list-inside{
  list-style-position: inside;
}
.list-outside{
  list-style-position: outside;
}
.list-decimal{
  list-style-type: decimal;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-\\[140px_1fr\\]{
  grid-template-columns: 140px 1fr;
}
.grid-cols-\\[1fr_5rem\\]{
  grid-template-columns: 1fr 5rem;
}
.grid-cols-\\[auto_10px_1fr_auto\\]{
  grid-template-columns: auto 10px 1fr auto;
}
.grid-cols-\\[auto_1fr\\]{
  grid-template-columns: auto 1fr;
}
.grid-cols-\\[auto_auto_auto\\]{
  grid-template-columns: auto auto auto;
}
.grid-cols-\\[auto_repeat\\(3\\2c auto\\)\\]{
  grid-template-columns: auto repeat(3,auto);
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_auto\\]{
  grid-template-columns: minmax(0,1fr) auto;
}
.grid-cols-\\[minmax\\(var\\(--component-gantt-label-min-width\\)\\2c var\\(--component-gantt-label-max-width\\)\\)_minmax\\(var\\(--component-gantt-track-min-width\\)\\2c 1fr\\)\\]{
  grid-template-columns: minmax(var(--component-gantt-label-min-width),var(--component-gantt-label-max-width)) minmax(var(--component-gantt-track-min-width),1fr);
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(120px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(120px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(min\\(100\\%\\2c var\\(--component-visual-column-min\\)\\)\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(min(100%,var(--component-visual-column-min)),1fr));
}
.grid-cols-\\[var\\(--component-job-state-column\\)_minmax\\(0\\2c 1fr\\)_var\\(--component-job-percent-column\\)\\]{
  grid-template-columns: var(--component-job-state-column) minmax(0,1fr) var(--component-job-percent-column);
}
.grid-cols-\\[var\\(--component-timeline-date-column\\)_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: var(--component-timeline-date-column) minmax(0,1fr);
}
.grid-cols-\\[var\\(--component-timeline-marker-column\\)_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: var(--component-timeline-marker-column) minmax(0,1fr);
}
.grid-cols-\\[var\\(--space-12\\)_repeat\\(5\\2c minmax\\(0\\2c 1fr\\)\\)\\]{
  grid-template-columns: var(--space-12) repeat(5,minmax(0,1fr));
}
.grid-cols-\\[var\\(--space-12\\)_repeat\\(7\\2c minmax\\(0\\2c 1fr\\)\\)\\]{
  grid-template-columns: var(--space-12) repeat(7,minmax(0,1fr));
}
.grid-rows-4{
  grid-template-rows: repeat(4, minmax(0, 1fr));
}
.grid-rows-\\[40px_40px_40px\\]{
  grid-template-rows: 40px 40px 40px;
}
.grid-rows-\\[minmax\\(var\\(--component-master-list-min-height\\)\\2c 0\\.45fr\\)_minmax\\(var\\(--component-master-detail-min-height\\)\\2c 1fr\\)\\]{
  grid-template-rows: minmax(var(--component-master-list-min-height),0.45fr) minmax(var(--component-master-detail-min-height),1fr);
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.place-items-center{
  place-items: center;
}
.content-start{
  align-content: flex-start;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-3\\.5{
  gap: 0.875rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[26px\\]{
  gap: 26px;
}
.gap-\\[3px\\]{
  gap: 3px;
}
.gap-\\[5px\\]{
  gap: 5px;
}
.gap-\\[6px\\]{
  gap: 6px;
}
.gap-\\[7px\\]{
  gap: 7px;
}
.gap-\\[9px\\]{
  gap: 9px;
}
.gap-\\[var\\(--space-0-5\\)\\]{
  gap: var(--space-0-5);
}
.gap-\\[var\\(--space-1\\)\\]{
  gap: var(--space-1);
}
.gap-\\[var\\(--space-1-5\\)\\]{
  gap: var(--space-1-5);
}
.gap-\\[var\\(--space-12\\)\\]{
  gap: var(--space-12);
}
.gap-\\[var\\(--space-2\\)\\]{
  gap: var(--space-2);
}
.gap-\\[var\\(--space-2-5\\)\\]{
  gap: var(--space-2-5);
}
.gap-\\[var\\(--space-3\\)\\]{
  gap: var(--space-3);
}
.gap-\\[var\\(--space-4\\)\\]{
  gap: var(--space-4);
}
.gap-\\[var\\(--space-5\\)\\]{
  gap: var(--space-5);
}
.gap-\\[var\\(--space-6\\)\\]{
  gap: var(--space-6);
}
.gap-\\[var\\(--space-7\\)\\]{
  gap: var(--space-7);
}
.gap-\\[var\\(--space-card\\)\\]{
  gap: var(--space-card);
}
.gap-\\[var\\(--space-kpi-gap\\)\\]{
  gap: var(--space-kpi-gap);
}
.gap-\\[var\\(--space-progress-gap\\)\\]{
  gap: var(--space-progress-gap);
}
.gap-\\[var\\(--space-ui-gap\\)\\]{
  gap: var(--space-ui-gap);
}
.gap-\\[var\\(--stroke-thin\\)\\]{
  gap: var(--stroke-thin);
}
.gap-px{
  gap: 1px;
}
.gap-x-1{
  -moz-column-gap: 0.25rem;
       column-gap: 0.25rem;
}
.gap-x-2{
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.gap-x-3{
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.gap-x-4{
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.gap-x-6{
  -moz-column-gap: 1.5rem;
       column-gap: 1.5rem;
}
.gap-x-\\[var\\(--space-2\\)\\]{
  -moz-column-gap: var(--space-2);
       column-gap: var(--space-2);
}
.gap-x-\\[var\\(--space-3\\)\\]{
  -moz-column-gap: var(--space-3);
       column-gap: var(--space-3);
}
.gap-x-\\[var\\(--space-card\\)\\]{
  -moz-column-gap: var(--space-card);
       column-gap: var(--space-card);
}
.gap-y-0\\.5{
  row-gap: 0.125rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-1\\.5{
  row-gap: 0.375rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.gap-y-3{
  row-gap: 0.75rem;
}
.gap-y-4{
  row-gap: 1rem;
}
.gap-y-\\[var\\(--space-0-5\\)\\]{
  row-gap: var(--space-0-5);
}
.gap-y-\\[var\\(--space-1\\)\\]{
  row-gap: var(--space-1);
}
.gap-y-\\[var\\(--space-2\\)\\]{
  row-gap: var(--space-2);
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-\\[var\\(--space-1-5\\)\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(calc(var(--space-1-5) * -1) * var(--tw-space-x-reverse));
  margin-left: calc(calc(var(--space-1-5) * -1) * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.space-y-\\[22px\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(22px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(22px * var(--tw-space-y-reverse));
}
.space-y-\\[var\\(--space-0-5\\)\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--space-0-5) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--space-0-5) * var(--tw-space-y-reverse));
}
.space-y-\\[var\\(--space-1\\)\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--space-1) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--space-1) * var(--tw-space-y-reverse));
}
.space-y-\\[var\\(--space-1-5\\)\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--space-1-5) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--space-1-5) * var(--tw-space-y-reverse));
}
.space-y-\\[var\\(--space-2\\)\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--space-2) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--space-2) * var(--tw-space-y-reverse));
}
.space-y-\\[var\\(--space-2-5\\)\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--space-2-5) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--space-2-5) * var(--tw-space-y-reverse));
}
.space-y-\\[var\\(--space-3\\)\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--space-3) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--space-3) * var(--tw-space-y-reverse));
}
.space-y-\\[var\\(--space-3-5\\)\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--space-3-5) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--space-3-5) * var(--tw-space-y-reverse));
}
.space-y-\\[var\\(--space-4\\)\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--space-4) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--space-4) * var(--tw-space-y-reverse));
}
.space-y-\\[var\\(--space-5\\)\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--space-5) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--space-5) * var(--tw-space-y-reverse));
}
.space-y-\\[var\\(--space-6\\)\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--space-6) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--space-6) * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-\\[color\\:var\\(--border-default\\)\\] > :not([hidden]) ~ :not([hidden]){
  border-color: var(--border-default);
}
.divide-border > :not([hidden]) ~ :not([hidden]){
  border-color: hsl(var(--border));
}
.divide-border\\/40 > :not([hidden]) ~ :not([hidden]){
  border-color: hsl(var(--border) / 0.4);
}
.divide-border\\/60 > :not([hidden]) ~ :not([hidden]){
  border-color: hsl(var(--border) / 0.6);
}
.divide-border\\/70 > :not([hidden]) ~ :not([hidden]){
  border-color: hsl(var(--border) / 0.7);
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity));
}
.divide-gray-50 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-divide-opacity));
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity));
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre{
  white-space: pre;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.text-balance{
  text-wrap: balance;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[1px\\]{
  border-radius: 1px;
}
.rounded-\\[2px\\]{
  border-radius: 2px;
}
.rounded-\\[3px\\]{
  border-radius: 3px;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-\\[6px\\]{
  border-radius: 6px;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-\\[var\\(--radius-badge\\)\\]{
  border-radius: var(--radius-badge);
}
.rounded-\\[var\\(--radius-card\\)\\]{
  border-radius: var(--radius-card);
}
.rounded-\\[var\\(--radius-control\\)\\]{
  border-radius: var(--radius-control);
}
.rounded-\\[var\\(--radius-lg\\)\\]{
  border-radius: var(--radius-lg);
}
.rounded-\\[var\\(--radius-md\\)\\]{
  border-radius: var(--radius-md);
}
.rounded-\\[var\\(--radius-pill\\)\\]{
  border-radius: var(--radius-pill);
}
.rounded-\\[var\\(--radius-sm\\)\\]{
  border-radius: var(--radius-sm);
}
.rounded-\\[var\\(--radius-xl\\)\\]{
  border-radius: var(--radius-xl);
}
.rounded-\\[var\\(--radius-xs\\)\\]{
  border-radius: var(--radius-xs);
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-2xl{
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-lg{
  border-bottom-right-radius: var(--radius);
  border-bottom-left-radius: var(--radius);
}
.rounded-l-\\[20px\\]{
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.rounded-l-\\[var\\(--radius-xl\\)\\]{
  border-top-left-radius: var(--radius-xl);
  border-bottom-left-radius: var(--radius-xl);
}
.rounded-r{
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-r-\\[var\\(--radius-sm\\)\\]{
  border-top-right-radius: var(--radius-sm);
  border-bottom-right-radius: var(--radius-sm);
}
.rounded-r-\\[var\\(--radius-xl\\)\\]{
  border-top-right-radius: var(--radius-xl);
  border-bottom-right-radius: var(--radius-xl);
}
.rounded-r-\\[var\\(--radius-xs\\)\\]{
  border-top-right-radius: var(--radius-xs);
  border-bottom-right-radius: var(--radius-xs);
}
.rounded-t{
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-2xl{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-\\[var\\(--radius-sm\\)\\]{
  border-top-left-radius: var(--radius-sm);
  border-top-right-radius: var(--radius-sm);
}
.rounded-t-\\[var\\(--radius-xs\\)\\]{
  border-top-left-radius: var(--radius-xs);
  border-top-right-radius: var(--radius-xs);
}
.rounded-t-md{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-top-right-radius: calc(var(--radius) - 2px);
}
.rounded-bl-\\[var\\(--radius-rail\\)\\]{
  border-bottom-left-radius: var(--radius-rail);
}
.rounded-tl-xl{
  border-top-left-radius: 0.75rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[1\\.5px\\]{
  border-width: 1.5px;
}
.border-\\[3px\\]{
  border-width: 3px;
}
.border-x{
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-x-0{
  border-left-width: 0px;
  border-right-width: 0px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-0{
  border-bottom-width: 0px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-l-\\[length\\:var\\(--component-quote-rule\\)\\]{
  border-left-width: var(--component-quote-rule);
}
.border-l-\\[length\\:var\\(--component-selected-rule-width\\)\\]{
  border-left-width: var(--component-selected-rule-width);
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-0{
  border-top-width: 0px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-solid{
  border-style: solid;
}
.border-dashed{
  border-style: dashed;
}
.border-dotted{
  border-style: dotted;
}
.border-none{
  border-style: none;
}
.border-\\[--color-border\\]{
  border-color: var(--color-border);
}
.border-\\[color\\:var\\(--border-card\\)\\]{
  border-color: var(--border-card);
}
.border-\\[color\\:var\\(--border-control\\)\\]{
  border-color: var(--border-control);
}
.border-\\[color\\:var\\(--border-dashed\\)\\]{
  border-color: var(--border-dashed);
}
.border-\\[color\\:var\\(--border-default\\)\\]{
  border-color: var(--border-default);
}
.border-\\[color\\:var\\(--border-subtle\\)\\]{
  border-color: var(--border-subtle);
}
.border-\\[color\\:var\\(--chart-bad\\)\\]{
  border-color: var(--chart-bad);
}
.border-\\[color\\:var\\(--chart-cat-1\\)\\]{
  border-color: var(--chart-cat-1);
}
.border-\\[color\\:var\\(--chart-cat-2\\)\\]{
  border-color: var(--chart-cat-2);
}
.border-\\[color\\:var\\(--chart-cat-3\\)\\]{
  border-color: var(--chart-cat-3);
}
.border-\\[color\\:var\\(--chart-cat-4\\)\\]{
  border-color: var(--chart-cat-4);
}
.border-\\[color\\:var\\(--chart-cat-5\\)\\]{
  border-color: var(--chart-cat-5);
}
.border-\\[color\\:var\\(--chart-cat-6\\)\\]{
  border-color: var(--chart-cat-6);
}
.border-\\[color\\:var\\(--chart-cat-7\\)\\]{
  border-color: var(--chart-cat-7);
}
.border-\\[color\\:var\\(--chart-cat-8\\)\\]{
  border-color: var(--chart-cat-8);
}
.border-\\[color\\:var\\(--chart-good\\)\\]{
  border-color: var(--chart-good);
}
.border-\\[color\\:var\\(--chart-grid\\)\\]{
  border-color: var(--chart-grid);
}
.border-\\[color\\:var\\(--chart-legacy\\)\\]{
  border-color: var(--chart-legacy);
}
.border-\\[color\\:var\\(--chart-other\\)\\]{
  border-color: var(--chart-other);
}
.border-\\[color\\:var\\(--chart-ours\\)\\]{
  border-color: var(--chart-ours);
}
.border-\\[color\\:var\\(--chart-ours-future\\)\\]{
  border-color: var(--chart-ours-future);
}
.border-\\[color\\:var\\(--chart-pending\\)\\]{
  border-color: var(--chart-pending);
}
.border-\\[color\\:var\\(--chart-series\\)\\]{
  border-color: var(--chart-series);
}
.border-\\[color\\:var\\(--chart-theirs\\)\\]{
  border-color: var(--chart-theirs);
}
.border-\\[color\\:var\\(--chart-theirs-future\\)\\]{
  border-color: var(--chart-theirs-future);
}
.border-\\[color\\:var\\(--chart-warn\\)\\]{
  border-color: var(--chart-warn);
}
.border-\\[color\\:var\\(--cta-bg\\)\\]{
  border-color: var(--cta-bg);
}
.border-\\[color\\:var\\(--surface-card\\)\\]{
  border-color: var(--surface-card);
}
.border-\\[color\\:var\\(--text-primary\\)\\]{
  border-color: var(--text-primary);
}
.border-\\[var\\(--border-card\\)\\]{
  border-color: var(--border-card);
}
.border-\\[var\\(--border-subtle\\)\\]{
  border-color: var(--border-subtle);
}
.border-accent\\/30{
  border-color: hsl(var(--accent) / 0.3);
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity));
}
.border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity));
}
.border-amber-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity));
}
.border-amber-600{
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity));
}
.border-background{
  border-color: hsl(var(--background));
}
.border-blue-100{
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity));
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity));
}
.border-blue-300{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity));
}
.border-blue-400{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity));
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.border-blue-600{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
}
.border-border{
  border-color: hsl(var(--border));
}
.border-border-strong{
  border-color: hsl(var(--border-strong));
}
.border-border\\/40{
  border-color: hsl(var(--border) / 0.4);
}
.border-border\\/50{
  border-color: hsl(var(--border) / 0.5);
}
.border-border\\/60{
  border-color: hsl(var(--border) / 0.6);
}
.border-border\\/70{
  border-color: hsl(var(--border) / 0.7);
}
.border-brand{
  border-color: hsl(var(--brand));
}
.border-brand\\/20{
  border-color: hsl(var(--brand) / 0.2);
}
.border-brand\\/30{
  border-color: hsl(var(--brand) / 0.3);
}
.border-current{
  border-color: currentColor;
}
.border-cyan-300{
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity));
}
.border-danger{
  border-color: hsl(var(--danger));
}
.border-danger\\/20{
  border-color: hsl(var(--danger) / 0.2);
}
.border-danger\\/25{
  border-color: hsl(var(--danger) / 0.25);
}
.border-danger\\/30{
  border-color: hsl(var(--danger) / 0.3);
}
.border-danger\\/40{
  border-color: hsl(var(--danger) / 0.4);
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/20{
  border-color: hsl(var(--destructive) / 0.2);
}
.border-destructive\\/30{
  border-color: hsl(var(--destructive) / 0.3);
}
.border-destructive\\/40{
  border-color: hsl(var(--destructive) / 0.4);
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity));
}
.border-emerald-300{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity));
}
.border-foreground{
  border-color: hsl(var(--foreground));
}
.border-foreground\\/10{
  border-color: hsl(var(--foreground) / 0.1);
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.border-gray-50{
  --tw-border-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-border-opacity));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity));
}
.border-green-300{
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity));
}
.border-green-500\\/20{
  border-color: rgb(34 197 94 / 0.2);
}
.border-green-600{
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity));
}
.border-indigo-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity));
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity));
}
.border-indigo-300{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity));
}
.border-indigo-50{
  --tw-border-opacity: 1;
  border-color: rgb(238 242 255 / var(--tw-border-opacity));
}
.border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
}
.border-indigo-600{
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity));
}
.border-info{
  border-color: hsl(var(--info));
}
.border-info\\/20{
  border-color: hsl(var(--info) / 0.2);
}
.border-input{
  border-color: hsl(var(--input));
}
.border-muted{
  border-color: hsl(var(--muted));
}
.border-muted-foreground\\/20{
  border-color: hsl(var(--muted-foreground) / 0.2);
}
.border-muted-foreground\\/25{
  border-color: hsl(var(--muted-foreground) / 0.25);
}
.border-muted-foreground\\/30{
  border-color: hsl(var(--muted-foreground) / 0.3);
}
.border-muted-foreground\\/40{
  border-color: hsl(var(--muted-foreground) / 0.4);
}
.border-muted-foreground\\/50{
  border-color: hsl(var(--muted-foreground) / 0.5);
}
.border-muted-foreground\\/60{
  border-color: hsl(var(--muted-foreground) / 0.6);
}
.border-orange-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity));
}
.border-orange-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity));
}
.border-orange-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity));
}
.border-orange\\/25{
  border-color: hsl(var(--orange) / 0.25);
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/30{
  border-color: hsl(var(--primary) / 0.3);
}
.border-primary\\/40{
  border-color: hsl(var(--primary) / 0.4);
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-primary\\/60{
  border-color: hsl(var(--primary) / 0.6);
}
.border-purple-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity));
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity));
}
.border-purple-300{
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity));
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.border-red-500\\/20{
  border-color: rgb(239 68 68 / 0.2);
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity));
}
.border-rose-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity));
}
.border-secondary\\/30{
  border-color: hsl(var(--secondary) / 0.3);
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity));
}
.border-slate-200\\/80{
  border-color: rgb(226 232 240 / 0.8);
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity));
}
.border-slate-50{
  --tw-border-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-border-opacity));
}
.border-slate-900{
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity));
}
.border-success{
  border-color: hsl(var(--success));
}
.border-success\\/20{
  border-color: hsl(var(--success) / 0.2);
}
.border-success\\/30{
  border-color: hsl(var(--success) / 0.3);
}
.border-success\\/40{
  border-color: hsl(var(--success) / 0.4);
}
.border-teal-300{
  --tw-border-opacity: 1;
  border-color: rgb(94 234 212 / var(--tw-border-opacity));
}
.border-teal\\/20{
  border-color: hsl(var(--teal) / 0.2);
}
.border-transparent{
  border-color: transparent;
}
.border-violet{
  border-color: hsl(var(--violet));
}
.border-violet-100{
  --tw-border-opacity: 1;
  border-color: rgb(237 233 254 / var(--tw-border-opacity));
}
.border-violet-200{
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity));
}
.border-violet\\/20{
  border-color: hsl(var(--violet) / 0.2);
}
.border-warning{
  border-color: hsl(var(--warning));
}
.border-warning\\/20{
  border-color: hsl(var(--warning) / 0.2);
}
.border-warning\\/25{
  border-color: hsl(var(--warning) / 0.25);
}
.border-warning\\/30{
  border-color: hsl(var(--warning) / 0.3);
}
.border-warning\\/40{
  border-color: hsl(var(--warning) / 0.4);
}
.border-warning\\/60{
  border-color: hsl(var(--warning) / 0.6);
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-yellow-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity));
}
.border-yellow-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity));
}
.border-l-amber-400{
  --tw-border-opacity: 1;
  border-left-color: rgb(251 191 36 / var(--tw-border-opacity));
}
.border-l-amber-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(245 158 11 / var(--tw-border-opacity));
}
.border-l-blue-400{
  --tw-border-opacity: 1;
  border-left-color: rgb(96 165 250 / var(--tw-border-opacity));
}
.border-l-blue-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.border-l-destructive{
  border-left-color: hsl(var(--destructive));
}
.border-l-emerald-400{
  --tw-border-opacity: 1;
  border-left-color: rgb(52 211 153 / var(--tw-border-opacity));
}
.border-l-emerald-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(16 185 129 / var(--tw-border-opacity));
}
.border-l-purple-400{
  --tw-border-opacity: 1;
  border-left-color: rgb(192 132 252 / var(--tw-border-opacity));
}
.border-l-red-400{
  --tw-border-opacity: 1;
  border-left-color: rgb(248 113 113 / var(--tw-border-opacity));
}
.border-l-red-600{
  --tw-border-opacity: 1;
  border-left-color: rgb(220 38 38 / var(--tw-border-opacity));
}
.border-l-rose-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(244 63 94 / var(--tw-border-opacity));
}
.border-l-slate-300{
  --tw-border-opacity: 1;
  border-left-color: rgb(203 213 225 / var(--tw-border-opacity));
}
.border-l-slate-400{
  --tw-border-opacity: 1;
  border-left-color: rgb(148 163 184 / var(--tw-border-opacity));
}
.border-l-slate-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(100 116 139 / var(--tw-border-opacity));
}
.border-l-success{
  border-left-color: hsl(var(--success));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-l-violet-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(139 92 246 / var(--tw-border-opacity));
}
.border-l-warning{
  border-left-color: hsl(var(--warning));
}
.border-t-blue-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.border-t-brand{
  border-top-color: hsl(var(--brand));
}
.border-t-foreground{
  border-top-color: hsl(var(--foreground));
}
.border-t-transparent{
  border-top-color: transparent;
}
.\\!bg-zinc-950{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity)) !important;
}
.bg-\\[--color-bg\\]{
  background-color: var(--color-bg);
}
.bg-\\[color-mix\\(in_srgb\\2c var\\(--surface-card\\)_80\\%\\2c transparent\\)\\]{
  background-color: color-mix(in srgb,var(--surface-card) 80%,transparent);
}
.bg-\\[color\\:var\\(--cta-bg\\)\\]{
  background-color: var(--cta-bg);
}
.bg-\\[color\\:var\\(--surface-canvas\\)\\]{
  background-color: var(--surface-canvas);
}
.bg-\\[color\\:var\\(--surface-chip\\)\\]{
  background-color: var(--surface-chip);
}
.bg-\\[color\\:var\\(--surface-page\\)\\]{
  background-color: var(--surface-page);
}
.bg-\\[color\\:var\\(--surface-panel\\)\\]{
  background-color: var(--surface-panel);
}
.bg-\\[color\\:var\\(--surface-rail\\)\\]{
  background-color: var(--surface-rail);
}
.bg-\\[color\\:var\\(--surface-row-highlight\\)\\]{
  background-color: var(--surface-row-highlight);
}
.bg-\\[color\\:var\\(--surface-sunken\\)\\]{
  background-color: var(--surface-sunken);
}
.bg-\\[color\\:var\\(--text-muted\\)\\]{
  background-color: var(--text-muted);
}
.bg-\\[color\\:var\\(--text-primary\\)\\]{
  background-color: var(--text-primary);
}
.bg-\\[var\\(--avatar-background\\)\\]{
  background-color: var(--avatar-background);
}
.bg-\\[var\\(--chart-bad\\)\\]{
  background-color: var(--chart-bad);
}
.bg-\\[var\\(--chart-cat-1\\)\\]{
  background-color: var(--chart-cat-1);
}
.bg-\\[var\\(--chart-cat-2\\)\\]{
  background-color: var(--chart-cat-2);
}
.bg-\\[var\\(--chart-cat-3\\)\\]{
  background-color: var(--chart-cat-3);
}
.bg-\\[var\\(--chart-cat-4\\)\\]{
  background-color: var(--chart-cat-4);
}
.bg-\\[var\\(--chart-cat-5\\)\\]{
  background-color: var(--chart-cat-5);
}
.bg-\\[var\\(--chart-cat-6\\)\\]{
  background-color: var(--chart-cat-6);
}
.bg-\\[var\\(--chart-cat-7\\)\\]{
  background-color: var(--chart-cat-7);
}
.bg-\\[var\\(--chart-cat-8\\)\\]{
  background-color: var(--chart-cat-8);
}
.bg-\\[var\\(--chart-good\\)\\]{
  background-color: var(--chart-good);
}
.bg-\\[var\\(--chart-heat-0\\)\\]{
  background-color: var(--chart-heat-0);
}
.bg-\\[var\\(--chart-heat-1\\)\\]{
  background-color: var(--chart-heat-1);
}
.bg-\\[var\\(--chart-heat-2\\)\\]{
  background-color: var(--chart-heat-2);
}
.bg-\\[var\\(--chart-heat-3\\)\\]{
  background-color: var(--chart-heat-3);
}
.bg-\\[var\\(--chart-heat-4\\)\\]{
  background-color: var(--chart-heat-4);
}
.bg-\\[var\\(--chart-legacy\\)\\]{
  background-color: var(--chart-legacy);
}
.bg-\\[var\\(--chart-other\\)\\]{
  background-color: var(--chart-other);
}
.bg-\\[var\\(--chart-ours\\)\\]{
  background-color: var(--chart-ours);
}
.bg-\\[var\\(--chart-ours-future\\)\\]{
  background-color: var(--chart-ours-future);
}
.bg-\\[var\\(--chart-pending\\)\\]{
  background-color: var(--chart-pending);
}
.bg-\\[var\\(--chart-series\\)\\]{
  background-color: var(--chart-series);
}
.bg-\\[var\\(--chart-theirs\\)\\]{
  background-color: var(--chart-theirs);
}
.bg-\\[var\\(--chart-theirs-future\\)\\]{
  background-color: var(--chart-theirs-future);
}
.bg-\\[var\\(--chart-warn\\)\\]{
  background-color: var(--chart-warn);
}
.bg-\\[var\\(--color-diff-delete-bg\\)\\]{
  background-color: var(--color-diff-delete-bg);
}
.bg-\\[var\\(--color-diff-insert-bg\\)\\]{
  background-color: var(--color-diff-insert-bg);
}
.bg-\\[var\\(--scrim\\)\\]{
  background-color: var(--scrim);
}
.bg-\\[var\\(--surface-card\\)\\]{
  background-color: var(--surface-card);
}
.bg-\\[var\\(--surface-panel\\)\\]{
  background-color: var(--surface-panel);
}
.bg-\\[var\\(--surface-rail\\)\\]{
  background-color: var(--surface-rail);
}
.bg-\\[var\\(--switch-thumb-background\\)\\]{
  background-color: var(--switch-thumb-background);
}
.bg-\\[var\\(--tooltip-background\\)\\]{
  background-color: var(--tooltip-background);
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-accent\\/10{
  background-color: hsl(var(--accent) / 0.1);
}
.bg-accent\\/40{
  background-color: hsl(var(--accent) / 0.4);
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity));
}
.bg-amber-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity));
}
.bg-amber-50\\/40{
  background-color: rgb(255 251 235 / 0.4);
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}
.bg-amber-500\\/10{
  background-color: rgb(245 158 11 / 0.1);
}
.bg-amber-600{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-background\\/50{
  background-color: hsl(var(--background) / 0.5);
}
.bg-background\\/80{
  background-color: hsl(var(--background) / 0.8);
}
.bg-background\\/90{
  background-color: hsl(var(--background) / 0.9);
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.bg-blue-400{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
.bg-blue-50\\/30{
  background-color: rgb(239 246 255 / 0.3);
}
.bg-blue-50\\/50{
  background-color: rgb(239 246 255 / 0.5);
}
.bg-blue-50\\/60{
  background-color: rgb(239 246 255 / 0.6);
}
.bg-blue-50\\/90{
  background-color: rgb(239 246 255 / 0.9);
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.bg-blue-500\\/10{
  background-color: rgb(59 130 246 / 0.1);
}
.bg-blue-500\\/80{
  background-color: rgb(59 130 246 / 0.8);
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-border-strong{
  background-color: hsl(var(--border-strong));
}
.bg-brand{
  background-color: hsl(var(--brand));
}
.bg-brand-muted{
  background-color: hsl(var(--brand-muted));
}
.bg-brand-muted\\/30{
  background-color: hsl(var(--brand-muted) / 0.3);
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-current{
  background-color: currentColor;
}
.bg-cyan-100{
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity));
}
.bg-cyan-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity));
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity));
}
.bg-danger{
  background-color: hsl(var(--danger));
}
.bg-danger-muted{
  background-color: hsl(var(--danger-muted));
}
.bg-danger-muted\\/60{
  background-color: hsl(var(--danger-muted) / 0.6);
}
.bg-danger\\/10{
  background-color: hsl(var(--danger) / 0.1);
}
.bg-danger\\/80{
  background-color: hsl(var(--danger) / 0.8);
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-destructive\\/10{
  background-color: hsl(var(--destructive) / 0.1);
}
.bg-destructive\\/5{
  background-color: hsl(var(--destructive) / 0.05);
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity));
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity));
}
.bg-emerald-50\\/40{
  background-color: rgb(236 253 245 / 0.4);
}
.bg-emerald-50\\/60{
  background-color: rgb(236 253 245 / 0.6);
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}
.bg-emerald-500\\/10{
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/80{
  background-color: rgb(16 185 129 / 0.8);
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity));
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-foreground\\/10{
  background-color: hsl(var(--foreground) / 0.1);
}
.bg-foreground\\/15{
  background-color: hsl(var(--foreground) / 0.15);
}
.bg-foreground\\/25{
  background-color: hsl(var(--foreground) / 0.25);
}
.bg-foreground\\/40{
  background-color: hsl(var(--foreground) / 0.4);
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-gray-50\\/50{
  background-color: rgb(249 250 251 / 0.5);
}
.bg-gray-50\\/80{
  background-color: rgb(249 250 251 / 0.8);
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.bg-gray-600{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-green-400{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.bg-green-500\\/10{
  background-color: rgb(34 197 94 / 0.1);
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity));
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity));
}
.bg-indigo-50\\/30{
  background-color: rgb(238 242 255 / 0.3);
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity));
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}
.bg-info{
  background-color: hsl(var(--info));
}
.bg-info-muted{
  background-color: hsl(var(--info-muted));
}
.bg-info-muted\\/60{
  background-color: hsl(var(--info-muted) / 0.6);
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted-foreground{
  background-color: hsl(var(--muted-foreground));
}
.bg-muted-foreground\\/25{
  background-color: hsl(var(--muted-foreground) / 0.25);
}
.bg-muted-foreground\\/30{
  background-color: hsl(var(--muted-foreground) / 0.3);
}
.bg-muted-foreground\\/35{
  background-color: hsl(var(--muted-foreground) / 0.35);
}
.bg-muted-foreground\\/45{
  background-color: hsl(var(--muted-foreground) / 0.45);
}
.bg-muted-foreground\\/70{
  background-color: hsl(var(--muted-foreground) / 0.7);
}
.bg-muted\\/10{
  background-color: hsl(var(--muted) / 0.1);
}
.bg-muted\\/20{
  background-color: hsl(var(--muted) / 0.2);
}
.bg-muted\\/30{
  background-color: hsl(var(--muted) / 0.3);
}
.bg-muted\\/40{
  background-color: hsl(var(--muted) / 0.4);
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-muted\\/60{
  background-color: hsl(var(--muted) / 0.6);
}
.bg-muted\\/70{
  background-color: hsl(var(--muted) / 0.7);
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity));
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity));
}
.bg-orange-500\\/10{
  background-color: rgb(249 115 22 / 0.1);
}
.bg-orange-500\\/85{
  background-color: rgb(249 115 22 / 0.85);
}
.bg-orange-muted{
  background-color: hsl(var(--orange-muted));
}
.bg-pink-100{
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity));
}
.bg-pink-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity));
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-primary\\/5{
  background-color: hsl(var(--primary) / 0.05);
}
.bg-project-type-general{
  background-color: hsl(var(--project-type-general));
}
.bg-project-type-general\\/10{
  background-color: hsl(var(--project-type-general) / 0.1);
}
.bg-project-type-proposal{
  background-color: hsl(var(--project-type-proposal));
}
.bg-project-type-proposal\\/10{
  background-color: hsl(var(--project-type-proposal) / 0.1);
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity));
}
.bg-purple-400{
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity));
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity));
}
.bg-purple-50\\/30{
  background-color: rgb(250 245 255 / 0.3);
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity));
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.bg-red-400{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-red-500\\/10{
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/5{
  background-color: rgb(239 68 68 / 0.05);
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity));
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity));
}
.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity));
}
.bg-rose-600{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity));
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-secondary\\/10{
  background-color: hsl(var(--secondary) / 0.1);
}
.bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.bg-slate-200\\/60{
  background-color: rgb(226 232 240 / 0.6);
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.bg-slate-400{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity));
}
.bg-slate-50\\/40{
  background-color: rgb(248 250 252 / 0.4);
}
.bg-slate-50\\/50{
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-50\\/60{
  background-color: rgb(248 250 252 / 0.6);
}
.bg-slate-50\\/80{
  background-color: rgb(248 250 252 / 0.8);
}
.bg-slate-500{
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity));
}
.bg-slate-800{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity));
}
.bg-slate-900{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity));
}
.bg-success{
  background-color: hsl(var(--success));
}
.bg-success-muted{
  background-color: hsl(var(--success-muted));
}
.bg-success-muted\\/60{
  background-color: hsl(var(--success-muted) / 0.6);
}
.bg-success\\/10{
  background-color: hsl(var(--success) / 0.1);
}
.bg-teal-100{
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity));
}
.bg-teal-muted{
  background-color: hsl(var(--teal-muted));
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-50{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity));
}
.bg-violet-50\\/30{
  background-color: rgb(245 243 255 / 0.3);
}
.bg-violet-50\\/50{
  background-color: rgb(245 243 255 / 0.5);
}
.bg-violet-500{
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity));
}
.bg-violet-muted{
  background-color: hsl(var(--violet-muted));
}
.bg-warning{
  background-color: hsl(var(--warning));
}
.bg-warning-muted{
  background-color: hsl(var(--warning-muted));
}
.bg-warning-muted\\/60{
  background-color: hsl(var(--warning-muted) / 0.6);
}
.bg-warning\\/10{
  background-color: hsl(var(--warning) / 0.1);
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95{
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity));
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity));
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity));
}
.bg-yellow-600{
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity));
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-card{
  --tw-gradient-from: hsl(var(--card)) var(--tw-gradient-from-position);
  --tw-gradient-to: hsl(var(--card) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent{
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-black\\/10{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary{
  --tw-gradient-to: hsl(var(--primary) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--primary)) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-\\[length\\:200\\%_100\\%\\]{
  background-size: 200% 100%;
}
.bg-cover{
  background-size: cover;
}
.bg-center{
  background-position: center;
}
.fill-amber-400{
  fill: #fbbf24;
}
.fill-border{
  fill: hsl(var(--border));
}
.fill-current{
  fill: currentColor;
}
.fill-muted-foreground{
  fill: hsl(var(--muted-foreground));
}
.object-contain{
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover{
  -o-object-fit: cover;
     object-fit: cover;
}
.\\!p-4{
  padding: 1rem !important;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.p-\\[3px\\]{
  padding: 3px;
}
.p-\\[var\\(--space-0-5\\)\\]{
  padding: var(--space-0-5);
}
.p-\\[var\\(--space-1\\)\\]{
  padding: var(--space-1);
}
.p-\\[var\\(--space-2-5\\)\\]{
  padding: var(--space-2-5);
}
.p-\\[var\\(--space-3\\)\\]{
  padding: var(--space-3);
}
.p-\\[var\\(--space-4\\)\\]{
  padding: var(--space-4);
}
.p-\\[var\\(--space-5\\)\\]{
  padding: var(--space-5);
}
.p-\\[var\\(--space-6\\)\\]{
  padding: var(--space-6);
}
.p-\\[var\\(--space-8\\)\\]{
  padding: var(--space-8);
}
.p-\\[var\\(--space-card\\)\\]{
  padding: var(--space-card);
}
.p-\\[var\\(--space-row-y\\)\\]{
  padding: var(--space-row-y);
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[0\\.3rem\\]{
  padding-left: 0.3rem;
  padding-right: 0.3rem;
}
.px-\\[11px\\]{
  padding-left: 11px;
  padding-right: 11px;
}
.px-\\[18px\\]{
  padding-left: 18px;
  padding-right: 18px;
}
.px-\\[22px\\]{
  padding-left: 22px;
  padding-right: 22px;
}
.px-\\[7px\\]{
  padding-left: 7px;
  padding-right: 7px;
}
.px-\\[var\\(--component-page-padding-x\\)\\]{
  padding-left: var(--component-page-padding-x);
  padding-right: var(--component-page-padding-x);
}
.px-\\[var\\(--space-1\\)\\]{
  padding-left: var(--space-1);
  padding-right: var(--space-1);
}
.px-\\[var\\(--space-1-5\\)\\]{
  padding-left: var(--space-1-5);
  padding-right: var(--space-1-5);
}
.px-\\[var\\(--space-2\\)\\]{
  padding-left: var(--space-2);
  padding-right: var(--space-2);
}
.px-\\[var\\(--space-2-5\\)\\]{
  padding-left: var(--space-2-5);
  padding-right: var(--space-2-5);
}
.px-\\[var\\(--space-3\\)\\]{
  padding-left: var(--space-3);
  padding-right: var(--space-3);
}
.px-\\[var\\(--space-3-5\\)\\]{
  padding-left: var(--space-3-5);
  padding-right: var(--space-3-5);
}
.px-\\[var\\(--space-4\\)\\]{
  padding-left: var(--space-4);
  padding-right: var(--space-4);
}
.px-\\[var\\(--space-5\\)\\]{
  padding-left: var(--space-5);
  padding-right: var(--space-5);
}
.px-\\[var\\(--space-5-5\\)\\]{
  padding-left: var(--space-5-5);
  padding-right: var(--space-5-5);
}
.px-\\[var\\(--space-6\\)\\]{
  padding-left: var(--space-6);
  padding-right: var(--space-6);
}
.px-\\[var\\(--space-card\\)\\]{
  padding-left: var(--space-card);
  padding-right: var(--space-card);
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[0\\.2rem\\]{
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}
.py-\\[11px\\]{
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[13px\\]{
  padding-top: 13px;
  padding-bottom: 13px;
}
.py-\\[18px\\]{
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[5px\\]{
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[6px\\]{
  padding-top: 6px;
  padding-bottom: 6px;
}
.py-\\[7px\\]{
  padding-top: 7px;
  padding-bottom: 7px;
}
.py-\\[var\\(--space-0-5\\)\\]{
  padding-top: var(--space-0-5);
  padding-bottom: var(--space-0-5);
}
.py-\\[var\\(--space-1\\)\\]{
  padding-top: var(--space-1);
  padding-bottom: var(--space-1);
}
.py-\\[var\\(--space-1-5\\)\\]{
  padding-top: var(--space-1-5);
  padding-bottom: var(--space-1-5);
}
.py-\\[var\\(--space-2\\)\\]{
  padding-top: var(--space-2);
  padding-bottom: var(--space-2);
}
.py-\\[var\\(--space-2-5\\)\\]{
  padding-top: var(--space-2-5);
  padding-bottom: var(--space-2-5);
}
.py-\\[var\\(--space-3\\)\\]{
  padding-top: var(--space-3);
  padding-bottom: var(--space-3);
}
.py-\\[var\\(--space-3-5\\)\\]{
  padding-top: var(--space-3-5);
  padding-bottom: var(--space-3-5);
}
.py-\\[var\\(--space-4\\)\\]{
  padding-top: var(--space-4);
  padding-bottom: var(--space-4);
}
.py-\\[var\\(--space-5\\)\\]{
  padding-top: var(--space-5);
  padding-bottom: var(--space-5);
}
.py-\\[var\\(--space-5-5\\)\\]{
  padding-top: var(--space-5-5);
  padding-bottom: var(--space-5-5);
}
.py-\\[var\\(--space-6\\)\\]{
  padding-top: var(--space-6);
  padding-bottom: var(--space-6);
}
.py-\\[var\\(--space-8\\)\\]{
  padding-top: var(--space-8);
  padding-bottom: var(--space-8);
}
.py-\\[var\\(--space-row-y\\)\\]{
  padding-top: var(--space-row-y);
  padding-bottom: var(--space-row-y);
}
.py-\\[var\\(--space-status-y\\)\\]{
  padding-top: var(--space-status-y);
  padding-bottom: var(--space-status-y);
}
.py-px{
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-0\\.5{
  padding-bottom: 0.125rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-2\\.5{
  padding-bottom: 0.625rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-\\[18px\\]{
  padding-bottom: 18px;
}
.pb-\\[var\\(--component-page-padding-bottom\\)\\]{
  padding-bottom: var(--component-page-padding-bottom);
}
.pb-\\[var\\(--space-1\\)\\]{
  padding-bottom: var(--space-1);
}
.pb-\\[var\\(--space-1-5\\)\\]{
  padding-bottom: var(--space-1-5);
}
.pb-\\[var\\(--space-2\\)\\]{
  padding-bottom: var(--space-2);
}
.pb-\\[var\\(--space-3\\)\\]{
  padding-bottom: var(--space-3);
}
.pb-\\[var\\(--space-6\\)\\]{
  padding-bottom: var(--space-6);
}
.pb-\\[var\\(--space-8\\)\\]{
  padding-bottom: var(--space-8);
}
.pl-0{
  padding-left: 0px;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-14{
  padding-left: 3.5rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-3\\.5{
  padding-left: 0.875rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-7{
  padding-left: 1.75rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pl-\\[31px\\]{
  padding-left: 31px;
}
.pl-\\[calc\\(var\\(--component-attention-badge-width\\)\\+var\\(--space-3\\)\\)\\]{
  padding-left: calc(var(--component-attention-badge-width) + var(--space-3));
}
.pl-\\[var\\(--space-1\\)\\]{
  padding-left: var(--space-1);
}
.pl-\\[var\\(--space-1-5\\)\\]{
  padding-left: var(--space-1-5);
}
.pl-\\[var\\(--space-2\\)\\]{
  padding-left: var(--space-2);
}
.pl-\\[var\\(--space-3\\)\\]{
  padding-left: var(--space-3);
}
.pl-\\[var\\(--space-5\\)\\]{
  padding-left: var(--space-5);
}
.pl-\\[var\\(--space-8\\)\\]{
  padding-left: var(--space-8);
}
.pr-0{
  padding-right: 0px;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-1\\.5{
  padding-right: 0.375rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-24{
  padding-right: 6rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-7{
  padding-right: 1.75rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-\\[var\\(--space-1-5\\)\\]{
  padding-right: var(--space-1-5);
}
.pr-\\[var\\(--space-12\\)\\]{
  padding-right: var(--space-12);
}
.pr-\\[var\\(--space-2\\)\\]{
  padding-right: var(--space-2);
}
.pr-\\[var\\(--space-3\\)\\]{
  padding-right: var(--space-3);
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 0.125rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-1\\.5{
  padding-top: 0.375rem;
}
.pt-12{
  padding-top: 3rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-2\\.5{
  padding-top: 0.625rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-3\\.5{
  padding-top: 0.875rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.pt-\\[18px\\]{
  padding-top: 18px;
}
.pt-\\[26px\\]{
  padding-top: 26px;
}
.pt-\\[var\\(--component-page-padding-top\\)\\]{
  padding-top: var(--component-page-padding-top);
}
.pt-\\[var\\(--space-0-5\\)\\]{
  padding-top: var(--space-0-5);
}
.pt-\\[var\\(--space-2\\)\\]{
  padding-top: var(--space-2);
}
.pt-\\[var\\(--space-2-5\\)\\]{
  padding-top: var(--space-2-5);
}
.pt-\\[var\\(--space-3\\)\\]{
  padding-top: var(--space-3);
}
.pt-\\[var\\(--space-4\\)\\]{
  padding-top: var(--space-4);
}
.pt-\\[var\\(--space-6\\)\\]{
  padding-top: var(--space-6);
}
.pt-\\[var\\(--space-card\\)\\]{
  padding-top: var(--space-card);
}
.pt-px{
  padding-top: 1px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-baseline{
  vertical-align: baseline;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.align-bottom{
  vertical-align: bottom;
}
.font-\\[inherit\\]{
  font-family: inherit;
}
.font-display{
  font-family: var(--font-display);
}
.font-mono{
  font-family: IBM Plex Mono, ui-monospace, monospace;
}
.font-sans{
  font-family: var(--font-text);
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[0\\.5rem\\]{
  font-size: 0.5rem;
}
.text-\\[0\\.625rem\\]{
  font-size: 0.625rem;
}
.text-\\[0\\.6rem\\]{
  font-size: 0.6rem;
}
.text-\\[0\\.8em\\]{
  font-size: 0.8em;
}
.text-\\[10\\.5px\\]{
  font-size: 10.5px;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11\\.5px\\]{
  font-size: 11.5px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12\\.5px\\]{
  font-size: 12.5px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13\\.5px\\]{
  font-size: 13.5px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[24px\\]{
  font-size: 24px;
}
.text-\\[34px\\]{
  font-size: 34px;
}
.text-\\[46px\\]{
  font-size: 46px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-\\[length\\:inherit\\]{
  font-size: inherit;
}
.text-\\[length\\:var\\(--fs-audit-score\\)\\]{
  font-size: var(--fs-audit-score);
}
.text-\\[length\\:var\\(--fs-body-sm\\)\\]{
  font-size: var(--fs-body-sm);
}
.text-\\[length\\:var\\(--fs-h2\\)\\]{
  font-size: var(--fs-h2);
}
.text-\\[length\\:var\\(--fs-h3\\)\\]{
  font-size: var(--fs-h3);
}
.text-\\[length\\:var\\(--fs-h4\\)\\]{
  font-size: var(--fs-h4);
}
.text-\\[length\\:var\\(--fs-ui\\)\\]{
  font-size: var(--fs-ui);
}
.text-\\[length\\:var\\(--fs-ui-body\\)\\]{
  font-size: var(--fs-ui-body);
}
.text-\\[length\\:var\\(--fs-ui-caption\\)\\]{
  font-size: var(--fs-ui-caption);
}
.text-\\[length\\:var\\(--fs-ui-emphasis\\)\\]{
  font-size: var(--fs-ui-emphasis);
}
.text-\\[length\\:var\\(--fs-ui-eyebrow\\)\\]{
  font-size: var(--fs-ui-eyebrow);
}
.text-\\[length\\:var\\(--fs-ui-home-title\\)\\]{
  font-size: var(--fs-ui-home-title);
}
.text-\\[length\\:var\\(--fs-ui-label\\)\\]{
  font-size: var(--fs-ui-label);
}
.text-\\[length\\:var\\(--fs-ui-meta\\)\\]{
  font-size: var(--fs-ui-meta);
}
.text-\\[length\\:var\\(--fs-ui-micro\\)\\]{
  font-size: var(--fs-ui-micro);
}
.text-\\[length\\:var\\(--fs-ui-page-title\\)\\]{
  font-size: var(--fs-ui-page-title);
}
.text-\\[length\\:var\\(--fs-ui-title\\)\\]{
  font-size: var(--fs-ui-title);
}
.text-\\[length\\:var\\(--fs-ui-verdict\\)\\]{
  font-size: var(--fs-ui-verdict);
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.not-italic{
  font-style: normal;
}
.ordinal{
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-4{
  line-height: 1rem;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-\\[1\\.65\\]{
  line-height: 1.65;
}
.leading-\\[1\\.6\\]{
  line-height: 1.6;
}
.leading-\\[inherit\\]{
  line-height: inherit;
}
.leading-\\[var\\(--lh-body\\)\\]{
  line-height: var(--lh-body);
}
.leading-\\[var\\(--lh-home\\)\\]{
  line-height: var(--lh-home);
}
.leading-\\[var\\(--lh-snug\\)\\]{
  line-height: var(--lh-snug);
}
.leading-\\[var\\(--lh-tight\\)\\]{
  line-height: var(--lh-tight);
}
.leading-none{
  line-height: 1;
}
.leading-normal{
  line-height: 1.5;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[-0\\.01em\\]{
  letter-spacing: -0.01em;
}
.tracking-\\[0\\.02em\\]{
  letter-spacing: 0.02em;
}
.tracking-\\[0\\.04em\\]{
  letter-spacing: 0.04em;
}
.tracking-\\[0\\.05em\\]{
  letter-spacing: 0.05em;
}
.tracking-\\[0\\.06em\\]{
  letter-spacing: 0.06em;
}
.tracking-\\[0\\.07em\\]{
  letter-spacing: 0.07em;
}
.tracking-\\[0\\.08em\\]{
  letter-spacing: 0.08em;
}
.tracking-\\[var\\(--ls-body\\)\\]{
  letter-spacing: var(--ls-body);
}
.tracking-\\[var\\(--ls-display\\)\\]{
  letter-spacing: var(--ls-display);
}
.tracking-\\[var\\(--ls-key-hint\\)\\]{
  letter-spacing: var(--ls-key-hint);
}
.tracking-\\[var\\(--ls-ui-eyebrow\\)\\]{
  letter-spacing: var(--ls-ui-eyebrow);
}
.tracking-\\[var\\(--ls-ui-group\\)\\]{
  letter-spacing: var(--ls-ui-group);
}
.tracking-\\[var\\(--ls-ui-label\\)\\]{
  letter-spacing: var(--ls-ui-label);
}
.tracking-normal{
  letter-spacing: 0em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[color\\:var\\(--chart-bad\\)\\]{
  color: var(--chart-bad);
}
.text-\\[color\\:var\\(--chart-cat-1\\)\\]{
  color: var(--chart-cat-1);
}
.text-\\[color\\:var\\(--chart-cat-2\\)\\]{
  color: var(--chart-cat-2);
}
.text-\\[color\\:var\\(--chart-cat-3\\)\\]{
  color: var(--chart-cat-3);
}
.text-\\[color\\:var\\(--chart-cat-4\\)\\]{
  color: var(--chart-cat-4);
}
.text-\\[color\\:var\\(--chart-cat-5\\)\\]{
  color: var(--chart-cat-5);
}
.text-\\[color\\:var\\(--chart-cat-6\\)\\]{
  color: var(--chart-cat-6);
}
.text-\\[color\\:var\\(--chart-cat-7\\)\\]{
  color: var(--chart-cat-7);
}
.text-\\[color\\:var\\(--chart-cat-8\\)\\]{
  color: var(--chart-cat-8);
}
.text-\\[color\\:var\\(--chart-good\\)\\]{
  color: var(--chart-good);
}
.text-\\[color\\:var\\(--chart-heat-ink-strong\\)\\]{
  color: var(--chart-heat-ink-strong);
}
.text-\\[color\\:var\\(--chart-legacy\\)\\]{
  color: var(--chart-legacy);
}
.text-\\[color\\:var\\(--chart-other\\)\\]{
  color: var(--chart-other);
}
.text-\\[color\\:var\\(--chart-ours\\)\\]{
  color: var(--chart-ours);
}
.text-\\[color\\:var\\(--chart-ours-future\\)\\]{
  color: var(--chart-ours-future);
}
.text-\\[color\\:var\\(--chart-pending\\)\\]{
  color: var(--chart-pending);
}
.text-\\[color\\:var\\(--chart-series\\)\\]{
  color: var(--chart-series);
}
.text-\\[color\\:var\\(--chart-theirs\\)\\]{
  color: var(--chart-theirs);
}
.text-\\[color\\:var\\(--chart-theirs-future\\)\\]{
  color: var(--chart-theirs-future);
}
.text-\\[color\\:var\\(--chart-warn\\)\\]{
  color: var(--chart-warn);
}
.text-\\[color\\:var\\(--color-diff-delete-fg\\)\\]{
  color: var(--color-diff-delete-fg);
}
.text-\\[color\\:var\\(--color-diff-insert-fg\\)\\]{
  color: var(--color-diff-insert-fg);
}
.text-\\[color\\:var\\(--cta-text\\)\\]{
  color: var(--cta-text);
}
.text-\\[color\\:var\\(--text-faint\\)\\]{
  color: var(--text-faint);
}
.text-\\[color\\:var\\(--text-ghost\\)\\]{
  color: var(--text-ghost);
}
.text-\\[color\\:var\\(--text-muted\\)\\]{
  color: var(--text-muted);
}
.text-\\[color\\:var\\(--text-primary\\)\\]{
  color: var(--text-primary);
}
.text-\\[color\\:var\\(--text-secondary\\)\\]{
  color: var(--text-secondary);
}
.text-\\[color\\:var\\(--warning\\)\\]{
  color: var(--warning);
}
.text-\\[var\\(--avatar-foreground\\)\\]{
  color: var(--avatar-foreground);
}
.text-\\[var\\(--tooltip-foreground\\)\\]{
  color: var(--tooltip-foreground);
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-amber-400{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity));
}
.text-amber-700\\/70{
  color: rgb(180 83 9 / 0.7);
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity));
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity));
}
.text-background{
  color: hsl(var(--background));
}
.text-background\\/70{
  color: hsl(var(--background) / 0.7);
}
.text-blue-400{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}
.text-blue-700\\/70{
  color: rgb(29 78 216 / 0.7);
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}
.text-blue-900{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity));
}
.text-border-strong{
  color: hsl(var(--border-strong));
}
.text-brand{
  color: hsl(var(--brand));
}
.text-brand-foreground{
  color: hsl(var(--brand-foreground));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-cyan-700{
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity));
}
.text-cyan-800{
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity));
}
.text-danger{
  color: hsl(var(--danger));
}
.text-danger-foreground{
  color: hsl(var(--danger-foreground));
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-destructive\\/70{
  color: hsl(var(--destructive) / 0.7);
}
.text-destructive\\/90{
  color: hsl(var(--destructive) / 0.9);
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity));
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity));
}
.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/70{
  color: hsl(var(--foreground) / 0.7);
}
.text-foreground\\/80{
  color: hsl(var(--foreground) / 0.8);
}
.text-foreground\\/90{
  color: hsl(var(--foreground) / 0.9);
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity));
}
.text-green-900{
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity));
}
.text-indigo-400{
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity));
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity));
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity));
}
.text-indigo-800{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity));
}
.text-info{
  color: hsl(var(--info));
}
.text-inherit{
  color: inherit;
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-muted-foreground\\/40{
  color: hsl(var(--muted-foreground) / 0.4);
}
.text-muted-foreground\\/50{
  color: hsl(var(--muted-foreground) / 0.5);
}
.text-muted-foreground\\/60{
  color: hsl(var(--muted-foreground) / 0.6);
}
.text-muted-foreground\\/70{
  color: hsl(var(--muted-foreground) / 0.7);
}
.text-orange{
  color: hsl(var(--orange));
}
.text-orange-400{
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity));
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity));
}
.text-orange-800{
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity));
}
.text-pink-700{
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-primary\\/80{
  color: hsl(var(--primary) / 0.8);
}
.text-project-type-general{
  color: hsl(var(--project-type-general));
}
.text-project-type-general-foreground{
  color: hsl(var(--project-type-general-foreground));
}
.text-project-type-proposal{
  color: hsl(var(--project-type-proposal));
}
.text-project-type-proposal-foreground{
  color: hsl(var(--project-type-proposal-foreground));
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity));
}
.text-purple-800{
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity));
}
.text-purple-900{
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity));
}
.text-red-200{
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity));
}
.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity));
}
.text-rose-800{
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-sky-700{
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity));
}
.text-sky-800{
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity));
}
.text-success{
  color: hsl(var(--success));
}
.text-success-foreground{
  color: hsl(var(--success-foreground));
}
.text-teal{
  color: hsl(var(--teal));
}
.text-teal-800{
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity));
}
.text-transparent{
  color: transparent;
}
.text-violet{
  color: hsl(var(--violet));
}
.text-violet-400{
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity));
}
.text-violet-500{
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity));
}
.text-violet-600{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity));
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity));
}
.text-violet-700\\/80{
  color: rgb(109 40 217 / 0.8);
}
.text-warning{
  color: hsl(var(--warning));
}
.text-warning-foreground{
  color: hsl(var(--warning-foreground));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity));
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity));
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity));
}
.text-yellow-900{
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity));
}
.text-zinc-600{
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.no-underline{
  text-decoration-line: none;
}
.decoration-muted-foreground{
  text-decoration-color: hsl(var(--muted-foreground));
}
.decoration-dotted{
  text-decoration-style: dotted;
}
.decoration-1{
  text-decoration-thickness: 1px;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.placeholder-gray-400::-moz-placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}
.placeholder-gray-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}
.placeholder-muted-foreground::-moz-placeholder{
  color: hsl(var(--muted-foreground));
}
.placeholder-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}
.accent-\\[var\\(--primary\\)\\]{
  accent-color: var(--primary);
}
.accent-brand{
  accent-color: hsl(var(--brand));
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-45{
  opacity: 0.45;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_var\\(--component-selected-rule-width\\)_0_0_var\\(--text-primary\\)\\]{
  --tw-shadow: inset var(--component-selected-rule-width) 0 0 var(--text-primary);
  --tw-shadow-colored: inset 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[var\\(--shadow-md\\)\\]{
  --tw-shadow-color: var(--shadow-md);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[var\\(--shadow-sm\\)\\]{
  --tw-shadow-color: var(--shadow-sm);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[var\\(--shadow-xs\\)\\]{
  --tw-shadow-color: var(--shadow-xs);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-900\\/10{
  --tw-shadow-color: rgb(15 23 42 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.\\!outline{
  outline-style: solid !important;
}
.outline{
  outline-style: solid;
}
.outline-1{
  outline-width: 1px;
}
.outline-offset-1{
  outline-offset: 1px;
}
.outline-\\[color\\:var\\(--text-primary\\)\\]{
  outline-color: var(--text-primary);
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset{
  --tw-ring-inset: inset;
}
.ring-\\[var\\(--chart-bad\\)\\]{
  --tw-ring-color: var(--chart-bad);
}
.ring-\\[var\\(--chart-warn\\)\\]{
  --tw-ring-color: var(--chart-warn);
}
.ring-amber-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity));
}
.ring-amber-600\\/20{
  --tw-ring-color: rgb(217 119 6 / 0.2);
}
.ring-black\\/10{
  --tw-ring-color: rgb(0 0 0 / 0.1);
}
.ring-blue-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity));
}
.ring-blue-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity));
}
.ring-blue-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}
.ring-blue-500\\/20{
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
.ring-blue-600\\/20{
  --tw-ring-color: rgb(37 99 235 / 0.2);
}
.ring-border{
  --tw-ring-color: hsl(var(--border));
}
.ring-brand{
  --tw-ring-color: hsl(var(--brand));
}
.ring-card{
  --tw-ring-color: hsl(var(--card));
}
.ring-cyan-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 243 252 / var(--tw-ring-opacity));
}
.ring-cyan-600\\/20{
  --tw-ring-color: rgb(8 145 178 / 0.2);
}
.ring-emerald-500\\/20{
  --tw-ring-color: rgb(16 185 129 / 0.2);
}
.ring-emerald-600\\/20{
  --tw-ring-color: rgb(5 150 105 / 0.2);
}
.ring-foreground{
  --tw-ring-color: hsl(var(--foreground));
}
.ring-gray-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity));
}
.ring-gray-500\\/20{
  --tw-ring-color: rgb(107 114 128 / 0.2);
}
.ring-indigo-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(199 210 254 / var(--tw-ring-opacity));
}
.ring-orange-500\\/20{
  --tw-ring-color: rgb(249 115 22 / 0.2);
}
.ring-pink-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 207 232 / var(--tw-ring-opacity));
}
.ring-primary{
  --tw-ring-color: hsl(var(--primary));
}
.ring-red-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity));
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-rose-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 211 / var(--tw-ring-opacity));
}
.ring-slate-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity));
}
.ring-slate-200\\/80{
  --tw-ring-color: rgb(226 232 240 / 0.8);
}
.ring-slate-900{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(15 23 42 / var(--tw-ring-opacity));
}
.ring-violet-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(221 214 254 / var(--tw-ring-opacity));
}
.ring-violet-600\\/20{
  --tw-ring-color: rgb(124 58 237 / 0.2);
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}
.ring-offset-1{
  --tw-ring-offset-width: 1px;
}
.ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.ring-offset-\\[color\\:var\\(--surface-card\\)\\]{
  --tw-ring-offset-color: var(--surface-card);
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm{
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[1px\\]{
  --tw-backdrop-blur: blur(1px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\]{
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[box-shadow\\2c transform\\]{
  transition-property: box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[fill-opacity\\]{
  transition-property: fill-opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[filter\\]{
  transition-property: filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[stroke-opacity\\]{
  transition-property: stroke-opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\]{
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-transform{
  will-change: transform;
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in{
  --tw-enter-opacity: 0;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-150{
  animation-duration: 150ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.running{
  animation-play-state: running;
}
.paused{
  animation-play-state: paused;
}
.chat-loading-glimmer {
    background: linear-gradient(
      100deg,
      hsl(var(--muted-foreground)) 35%,
      hsl(var(--foreground)) 50%,
      hsl(var(--muted-foreground)) 65%
    );
    background-size: 250% 100%;
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    animation: chat-text-glimmer 2.8s ease-in-out infinite;
  }
@keyframes chat-text-glimmer {
    from {
      background-position: 200% 0;
    }
    to {
      background-position: -50% 0;
    }
  }
@media (prefers-reduced-motion: reduce) {
    .chat-loading-glimmer {
      animation: none;
      background: none;
      color: hsl(var(--muted-foreground));
    }
  }
.text-balance {
    text-wrap: balance;
  }
/* Workflow drawer slide-in animation */
@keyframes slide-in-right {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
/* Custom scrollbar utilities */
.scrollbar-thin {
    scrollbar-width: thin;
    scrollbar-color: hsl(var(--border)) transparent;
  }
.scrollbar-thin::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
.scrollbar-thin::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 3px;
  }
.scrollbar-thin::-webkit-scrollbar-thumb {
    background: hsl(var(--border));
    border-radius: 3px;
  }
.scrollbar-thin::-webkit-scrollbar-thumb:hover {
    background: hsl(var(--muted-foreground) / 0.5);
  }
.\\[border-color\\:color-mix\\(in_srgb\\2c currentColor_30\\%\\2c transparent\\)\\]{
  border-color: color-mix(in srgb,currentColor 30%,transparent);
}
.\\[border-top-color\\:currentColor\\]{
  border-top-color: currentColor;
}
.\\[cite\\:\\.\\.\\.\\]{
  cite: ...;
}
.\\[content-visibility\\:auto\\]{
  content-visibility: auto;
}
.\\[line-height\\:inherit\\]{
  line-height: inherit;
}
.\\[overflow-wrap\\:anywhere\\]{
  overflow-wrap: anywhere;
}
.\\[scrollbar-width\\:thin\\]{
  scrollbar-width: thin;
}

/* TipTap Editor Styles - Match EnhancedMarkdown component */
.tiptap {
  /* Base prose styling with color scheme */
  max-width: none;
  color: hsl(var(--foreground));

  /* Focus styles */
  &:focus{
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  /* Placeholder */
  p.is-editor-empty:first-child::before{
    color: hsl(var(--muted-foreground));
  }
  p.is-editor-empty:first-child::before {
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
  }

  /* Headings - Match EnhancedMarkdown exactly with slate color scheme */
  h1{
    margin-bottom: 1rem;
  }
  h1{
    margin-top: 1.5rem;
  }
  h1{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  h1{
    font-weight: 700;
  }
  h1:first-child{
    margin-top: 0px;
  }
  h1 {
    color: hsl(var(--foreground));
  }

  h2{
    margin-bottom: 0.75rem;
  }

  h2{
    margin-top: 1.5rem;
  }

  h2{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  h2{
    font-weight: 600;
  }

  h2:first-child{
    margin-top: 0px;
  }

  h2 {
    color: hsl(var(--foreground));
  }

  h3{
    margin-bottom: 0.5rem;
  }

  h3{
    margin-top: 1rem;
  }

  h3{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  h3{
    font-weight: 600;
  }

  h3:first-child{
    margin-top: 0px;
  }

  h3 {
    color: hsl(var(--foreground));
  }

  h4{
    margin-bottom: 0.5rem;
  }

  h4{
    margin-top: 0.75rem;
  }

  h4{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  h4{
    font-weight: 600;
  }

  h4:first-child{
    margin-top: 0px;
  }

  h4 {
    color: hsl(var(--foreground));
  }

  h5{
    margin-bottom: 0.5rem;
  }

  h5{
    margin-top: 0.75rem;
  }

  h5{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  h5{
    font-weight: 600;
  }

  h5:first-child{
    margin-top: 0px;
  }

  h5 {
    color: hsl(var(--foreground));
  }

  h6{
    margin-bottom: 0.5rem;
  }

  h6{
    margin-top: 0.75rem;
  }

  h6{
    font-size: 0.75rem;
    line-height: 1rem;
  }

  h6{
    font-weight: 600;
  }

  h6:first-child{
    margin-top: 0px;
  }

  h6 {
    color: hsl(var(--foreground));
  }

  /* Paragraphs */
  p{
    margin-bottom: 1rem;
  }
  p{
    font-size: 15px;
  }
  p{
    line-height: 1.75rem;
  }
  p:last-child{
    margin-bottom: 0px;
  }
  p {
    color: hsl(var(--foreground));
  }

  /* Lists with proper color */
  ul{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  ul{
    margin-left: 1.5rem;
  }
  ul{
    margin-bottom: 1rem;
  }
  ul{
    list-style-position: outside;
  }
  ul{
    list-style-type: disc;
  }
  ul > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
  }

  ol{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  ol{
    margin-left: 1.5rem;
  }

  ol{
    margin-bottom: 1rem;
  }

  ol{
    list-style-position: outside;
  }

  ol{
    list-style-type: decimal;
  }

  ol > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
  }

  li{
    margin-top: 0.125rem;
    margin-bottom: 0.125rem;
  }

  li{
    line-height: 1.75rem;
  }

  li {
    color: hsl(var(--foreground));
  }

  /* Nested lists */
  li > ul,
  li > ol{
    margin-top: 0.5rem;
  }
  li > ul,
  li > ol{
    margin-bottom: 0.5rem;
  }

  /* Blockquotes with proper styling */
  blockquote{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  blockquote{
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
  blockquote{
    border-left-width: 4px;
  }
  blockquote{
    border-color: hsl(var(--primary) / 0.5);
  }
  blockquote{
    background-color: hsl(var(--muted) / 0.3);
  }
  blockquote{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  blockquote{
    padding-left: 1rem;
  }
  blockquote{
    font-style: italic;
  }
  blockquote {
    color: hsl(var(--muted-foreground));
  }

  /* Tables with full styling - Match EnhancedMarkdown exactly */
  table{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  table{
    width: 100%;
  }
  table{
    border-collapse: collapse;
  }

  /* Wrap table in overflow container for horizontal scroll */
  .editor-table{
    width: 100%;
  }
  .editor-table{
    border-collapse: collapse;
  }
  .editor-table{
    border-radius: var(--radius);
  }
  .editor-table{
    border-width: 1px;
  }
  .editor-table{
    border-color: hsl(var(--border));
  }

  /* Table structure styling */
  thead{
    background-color: hsl(var(--muted));
  }

  tbody {
    background: transparent;
  }

  tr,
  .editor-table-row{
    border-bottom-width: 1px;
  }

  tr,
  .editor-table-row{
    border-color: hsl(var(--border));
  }

  tr,
  .editor-table-row {
    transition: background-color 0.15s ease;
  }

  /* Only hover on tbody rows, not header rows */
  tbody tr:hover,
  tbody .editor-table-row:hover{
    background-color: hsl(var(--muted) / 0.5);
  }

  /* Table header cells - gray background like inline preview */
  th,
  .editor-table-header{
    border-width: 1px;
  }
  th,
  .editor-table-header{
    border-color: hsl(var(--border));
  }
  th,
  .editor-table-header{
    background-color: hsl(var(--muted));
  }
  th,
  .editor-table-header{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  th,
  .editor-table-header{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  th,
  .editor-table-header{
    text-align: left;
  }
  th,
  .editor-table-header{
    font-weight: 600;
  }
  th,
  .editor-table-header {
    color: hsl(var(--foreground));
    position: relative;
  }

  /* Table data cells - transparent background */
  td,
  .editor-table-cell{
    border-width: 1px;
  }
  td,
  .editor-table-cell{
    border-color: hsl(var(--border));
  }
  td,
  .editor-table-cell{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  td,
  .editor-table-cell{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  td,
  .editor-table-cell {
    color: hsl(var(--foreground));
    background: transparent;
    position: relative;
  }

  /* Column resize handle */
  .column-resize-handle {
    position: absolute;
    right: -2px;
    top: 0;
    bottom: 0;
    width: 4px;
    cursor: col-resize;
    background-color: transparent;
    z-index: 10;
  }

  .column-resize-handle:hover {
    background-color: hsl(var(--primary) / 0.3);
  }

  .resize-cursor {
    cursor: col-resize;
  }

  /* Code blocks */
  pre{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  pre{
    overflow-x: auto;
  }
  pre{
    border-radius: var(--radius);
  }
  pre{
    --tw-bg-opacity: 1;
    background-color: rgb(9 9 11 / var(--tw-bg-opacity));
  }
  pre{
    padding: 1rem;
  }

  code{
    font-family: IBM Plex Mono, ui-monospace, monospace;
  }

  code{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  /* Inline code with proper background */
  p code,
  li code,
  h1 code,
  h2 code,
  h3 code,
  h4 code{
    position: relative;
  }
  p code,
  li code,
  h1 code,
  h2 code,
  h3 code,
  h4 code{
    border-radius: 0.25rem;
  }
  p code,
  li code,
  h1 code,
  h2 code,
  h3 code,
  h4 code{
    background-color: hsl(var(--muted));
  }
  p code,
  li code,
  h1 code,
  h2 code,
  h3 code,
  h4 code{
    padding-left: 0.3rem;
    padding-right: 0.3rem;
  }
  p code,
  li code,
  h1 code,
  h2 code,
  h3 code,
  h4 code{
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  }
  p code,
  li code,
  h1 code,
  h2 code,
  h3 code,
  h4 code{
    font-family: IBM Plex Mono, ui-monospace, monospace;
  }
  p code,
  li code,
  h1 code,
  h2 code,
  h3 code,
  h4 code{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  p code,
  li code,
  h1 code,
  h2 code,
  h3 code,
  h4 code{
    font-weight: 600;
  }
  p code,
  li code,
  h1 code,
  h2 code,
  h3 code,
  h4 code {
    color: hsl(var(--foreground));
  }

  /* Links */
  a{
    text-decoration-line: underline;
  }
  a{
    text-underline-offset: 4px;
  }
  a{
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
  a {
    color: hsl(var(--primary));
  }

  a:hover {
    color: hsl(var(--primary) / 0.8);
  }

  /* Strong and emphasis */
  strong{
    font-weight: 600;
  }
  strong {
    color: hsl(var(--foreground));
  }

  em{
    font-style: italic;
  }

  em {
    color: hsl(var(--foreground));
  }

  /* Horizontal rule */
  hr{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  hr{
    border-top-width: 1px;
  }
  hr {
    border-color: hsl(var(--border));
  }

  /* Selection color */
  ::-moz-selection{
    background-color: hsl(var(--primary) / 0.2);
  }
  ::selection{
    background-color: hsl(var(--primary) / 0.2);
  }
}

/* A figure in an answer that no source accounts for (lib/chat/figureHighlights).
   Top level: the answer body is not inside the editor's .tiptap scope. */
::highlight(specra-unverified) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  text-decoration-color: hsl(var(--warning));
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
}

/* Editor wrapper for better spacing */
.prose-editor-wrapper{
  width: 100%;
}

.prose-editor-wrapper .ProseMirror{
  min-height: 60vh;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.file\\:border-0::file-selector-button{
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}

.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-medium::file-selector-button{
  font-weight: 500;
}

.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}

.placeholder\\:text-\\[color\\:var\\(--text-placeholder\\)\\]::-moz-placeholder{
  color: var(--text-placeholder);
}

.placeholder\\:text-\\[color\\:var\\(--text-placeholder\\)\\]::placeholder{
  color: var(--text-placeholder);
}

.placeholder\\:text-muted-foreground::-moz-placeholder{
  color: hsl(var(--muted-foreground));
}

.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}

.placeholder\\:text-slate-400::-moz-placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity));
}

.placeholder\\:text-slate-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity));
}

.before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}

.before\\:inset-y-0::before{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}

.before\\:-left-3::before{
  content: var(--tw-content);
  left: -0.75rem;
}

.before\\:left-3::before{
  content: var(--tw-content);
  left: 0.75rem;
}

.before\\:top-1\\.5::before{
  content: var(--tw-content);
  top: 0.375rem;
}

.before\\:h-2::before{
  content: var(--tw-content);
  height: 0.5rem;
}

.before\\:w-0\\.5::before{
  content: var(--tw-content);
  width: 0.125rem;
}

.before\\:w-px::before{
  content: var(--tw-content);
  width: 1px;
}

.before\\:bg-emerald-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}

.before\\:bg-muted-foreground\\/30::before{
  content: var(--tw-content);
  background-color: hsl(var(--muted-foreground) / 0.3);
}

.before\\:content-\\[\\'\\'\\]::before{
  --tw-content: '';
  content: var(--tw-content);
}

.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}

.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}

.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}

.after\\:left-\\[2px\\]::after{
  content: var(--tw-content);
  left: 2px;
}

.after\\:top-\\[2px\\]::after{
  content: var(--tw-content);
  top: 2px;
}

.after\\:h-5::after{
  content: var(--tw-content);
  height: 1.25rem;
}

.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}

.after\\:w-5::after{
  content: var(--tw-content);
  width: 1.25rem;
}

.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:rounded-full::after{
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:border::after{
  content: var(--tw-content);
  border-width: 1px;
}

.after\\:border-gray-300::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.after\\:bg-white::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.after\\:transition-all::after{
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:content-\\[\\'\\'\\]::after{
  --tw-content: '';
  content: var(--tw-content);
}

.first\\:mt-0:first-child{
  margin-top: 0px;
}

.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.first\\:border-l:first-child{
  border-left-width: 1px;
}

.first\\:pl-0:first-child{
  padding-left: 0px;
}

.first\\:pl-2:first-child{
  padding-left: 0.5rem;
}

.first\\:pt-0:first-child{
  padding-top: 0px;
}

.last\\:mb-0:last-child{
  margin-bottom: 0px;
}

.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.last\\:border-0:last-child{
  border-width: 0px;
}

.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}

.last\\:pb-0:last-child{
  padding-bottom: 0px;
}

.last\\:pr-0:last-child{
  padding-right: 0px;
}

.focus-within\\:opacity-100:focus-within{
  opacity: 1;
}

.focus-within\\:outline-none:focus-within{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-inset:focus-within{
  --tw-ring-inset: inset;
}

.focus-within\\:ring-ring:focus-within{
  --tw-ring-color: hsl(var(--ring));
}

.hover\\:-translate-y-px:hover{
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-blue-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity));
}

.hover\\:border-blue-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity));
}

.hover\\:border-border:hover{
  border-color: hsl(var(--border));
}

.hover\\:border-border-strong:hover{
  border-color: hsl(var(--border-strong));
}

.hover\\:border-border\\/80:hover{
  border-color: hsl(var(--border) / 0.8);
}

.hover\\:border-brand:hover{
  border-color: hsl(var(--brand));
}

.hover\\:border-brand\\/30:hover{
  border-color: hsl(var(--brand) / 0.3);
}

.hover\\:border-foreground\\/30:hover{
  border-color: hsl(var(--foreground) / 0.3);
}

.hover\\:border-foreground\\/40:hover{
  border-color: hsl(var(--foreground) / 0.4);
}

.hover\\:border-gray-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.hover\\:border-gray-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}

.hover\\:border-indigo-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
}

.hover\\:border-muted-foreground:hover{
  border-color: hsl(var(--muted-foreground));
}

.hover\\:border-primary:hover{
  border-color: hsl(var(--primary));
}

.hover\\:border-primary\\/50:hover{
  border-color: hsl(var(--primary) / 0.5);
}

.hover\\:border-primary\\/60:hover{
  border-color: hsl(var(--primary) / 0.6);
}

.hover\\:border-red-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity));
}

.hover\\:border-slate-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity));
}

.hover\\:border-slate-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity));
}

.hover\\:border-warning:hover{
  border-color: hsl(var(--warning));
}

.hover\\:border-yellow-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity));
}

.hover\\:bg-\\[color\\:var\\(--surface-hover\\)\\]:hover{
  background-color: var(--surface-hover);
}

.hover\\:bg-\\[color\\:var\\(--surface-nav-hover\\)\\]:hover{
  background-color: var(--surface-nav-hover);
}

.hover\\:bg-\\[var\\(--surface-hover\\)\\]:hover{
  background-color: var(--surface-hover);
}

.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}

.hover\\:bg-accent\\/50:hover{
  background-color: hsl(var(--accent) / 0.5);
}

.hover\\:bg-accent\\/70:hover{
  background-color: hsl(var(--accent) / 0.7);
}

.hover\\:bg-accent\\/90:hover{
  background-color: hsl(var(--accent) / 0.9);
}

.hover\\:bg-amber-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity));
}

.hover\\:bg-amber-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}

.hover\\:bg-amber-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity));
}

.hover\\:bg-background\\/50:hover{
  background-color: hsl(var(--background) / 0.5);
}

.hover\\:bg-background\\/60:hover{
  background-color: hsl(var(--background) / 0.6);
}

.hover\\:bg-background\\/80:hover{
  background-color: hsl(var(--background) / 0.8);
}

.hover\\:bg-blue-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-50\\/30:hover{
  background-color: rgb(239 246 255 / 0.3);
}

.hover\\:bg-blue-50\\/50:hover{
  background-color: rgb(239 246 255 / 0.5);
}

.hover\\:bg-blue-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}

.hover\\:bg-border:hover{
  background-color: hsl(var(--border));
}

.hover\\:bg-brand\\/90:hover{
  background-color: hsl(var(--brand) / 0.9);
}

.hover\\:bg-card:hover{
  background-color: hsl(var(--card));
}

.hover\\:bg-danger-muted:hover{
  background-color: hsl(var(--danger-muted));
}

.hover\\:bg-danger\\/90:hover{
  background-color: hsl(var(--danger) / 0.9);
}

.hover\\:bg-destructive\\/10:hover{
  background-color: hsl(var(--destructive) / 0.1);
}

.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}

.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-emerald-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity));
}

.hover\\:bg-emerald-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity));
}

.hover\\:bg-emerald-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}

.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity));
}

.hover\\:bg-foreground\\/10:hover{
  background-color: hsl(var(--foreground) / 0.1);
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-50\\/50:hover{
  background-color: rgb(249 250 251 / 0.5);
}

.hover\\:bg-gray-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

.hover\\:bg-green-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}

.hover\\:bg-green-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity));
}

.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}

.hover\\:bg-indigo-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}

.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity));
}

.hover\\:bg-info-muted:hover{
  background-color: hsl(var(--info-muted));
}

.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}

.hover\\:bg-muted\\/20:hover{
  background-color: hsl(var(--muted) / 0.2);
}

.hover\\:bg-muted\\/30:hover{
  background-color: hsl(var(--muted) / 0.3);
}

.hover\\:bg-muted\\/40:hover{
  background-color: hsl(var(--muted) / 0.4);
}

.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}

.hover\\:bg-muted\\/70:hover{
  background-color: hsl(var(--muted) / 0.7);
}

.hover\\:bg-muted\\/80:hover{
  background-color: hsl(var(--muted) / 0.8);
}

.hover\\:bg-primary\\/10:hover{
  background-color: hsl(var(--primary) / 0.1);
}

.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}

.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}

.hover\\:bg-purple-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity));
}

.hover\\:bg-purple-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity));
}

.hover\\:bg-purple-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity));
}

.hover\\:bg-purple-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity));
}

.hover\\:bg-red-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity));
}

.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}

.hover\\:bg-red-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}

.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}

.hover\\:bg-rose-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity));
}

.hover\\:bg-rose-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity));
}

.hover\\:bg-secondary-foreground\\/20:hover{
  background-color: hsl(var(--secondary-foreground) / 0.2);
}

.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:bg-secondary\\/90:hover{
  background-color: hsl(var(--secondary) / 0.9);
}

.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}

.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}

.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity));
}

.hover\\:bg-slate-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity));
}

.hover\\:bg-success-muted:hover{
  background-color: hsl(var(--success-muted));
}

.hover\\:bg-transparent:hover{
  background-color: transparent;
}

.hover\\:bg-violet-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity));
}

.hover\\:bg-violet-muted:hover{
  background-color: hsl(var(--violet-muted));
}

.hover\\:bg-warning-muted:hover{
  background-color: hsl(var(--warning-muted));
}

.hover\\:bg-warning\\/10:hover{
  background-color: hsl(var(--warning) / 0.1);
}

.hover\\:bg-warning\\/90:hover{
  background-color: hsl(var(--warning) / 0.9);
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.hover\\:bg-white\\/50:hover{
  background-color: rgb(255 255 255 / 0.5);
}

.hover\\:bg-yellow-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity));
}

.hover\\:bg-yellow-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity));
}

.hover\\:bg-yellow-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / var(--tw-bg-opacity));
}

.hover\\:bg-opacity-30:hover{
  --tw-bg-opacity: 0.3;
}

.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}

.hover\\:text-amber-600:hover{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity));
}

.hover\\:text-amber-700:hover{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity));
}

.hover\\:text-blue-500:hover{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}

.hover\\:text-blue-600:hover{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}

.hover\\:text-blue-700:hover{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}

.hover\\:text-blue-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}

.hover\\:text-blue-900:hover{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity));
}

.hover\\:text-brand:hover{
  color: hsl(var(--brand));
}

.hover\\:text-danger:hover{
  color: hsl(var(--danger));
}

.hover\\:text-destructive:hover{
  color: hsl(var(--destructive));
}

.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}

.hover\\:text-gray-500:hover{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.hover\\:text-gray-600:hover{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}

.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}

.hover\\:text-gray-800:hover{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}

.hover\\:text-gray-900:hover{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}

.hover\\:text-indigo-800:hover{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity));
}

.hover\\:text-indigo-900:hover{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity));
}

.hover\\:text-info:hover{
  color: hsl(var(--info));
}

.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}

.hover\\:text-orange-700:hover{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity));
}

.hover\\:text-primary:hover{
  color: hsl(var(--primary));
}

.hover\\:text-primary\\/80:hover{
  color: hsl(var(--primary) / 0.8);
}

.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}

.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}

.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}

.hover\\:text-red-800:hover{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity));
}

.hover\\:text-rose-500:hover{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity));
}

.hover\\:text-rose-600:hover{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity));
}

.hover\\:text-rose-700:hover{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity));
}

.hover\\:text-slate-600:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}

.hover\\:text-slate-700:hover{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity));
}

.hover\\:text-slate-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity));
}

.hover\\:text-slate-900:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity));
}

.hover\\:text-success:hover{
  color: hsl(var(--success));
}

.hover\\:text-warning:hover{
  color: hsl(var(--warning));
}

.hover\\:text-yellow-700:hover{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:no-underline:hover{
  text-decoration-line: none;
}

.hover\\:decoration-foreground:hover{
  text-decoration-color: hsl(var(--foreground));
}

.hover\\:decoration-solid:hover{
  text-decoration-style: solid;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.hover\\:opacity-80:hover{
  opacity: 0.8;
}

.hover\\:opacity-90:hover{
  opacity: 0.9;
}

.hover\\:shadow:hover{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[var\\(--shadow-md\\)\\]:hover{
  --tw-shadow-color: var(--shadow-md);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:brightness-95:hover{
  --tw-brightness: brightness(.95);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.hover\\:\\[fill-opacity\\:0\\.6\\]:hover{
  fill-opacity: 0.6;
}

.focus\\:border-blue-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}

.focus\\:border-border-strong:focus{
  border-color: hsl(var(--border-strong));
}

.focus\\:border-emerald-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity));
}

.focus\\:border-indigo-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity));
}

.focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
}

.focus\\:border-transparent:focus{
  border-color: transparent;
}

.focus\\:border-violet-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity));
}

.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}

.focus\\:bg-danger-muted:focus{
  background-color: hsl(var(--danger-muted));
}

.focus\\:bg-red-50:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}

.focus\\:bg-warning-muted:focus{
  background-color: hsl(var(--warning-muted));
}

.focus\\:bg-yellow-50:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity));
}

.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}

.focus\\:text-danger:focus{
  color: hsl(var(--danger));
}

.focus\\:text-destructive:focus{
  color: hsl(var(--destructive));
}

.focus\\:text-red-700:focus{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}

.focus\\:text-warning:focus{
  color: hsl(var(--warning));
}

.focus\\:text-yellow-700:focus{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity));
}

.focus\\:text-yellow-800:focus{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity));
}

.focus\\:opacity-100:focus{
  opacity: 1;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-amber-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 158 11 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}

.focus\\:ring-brand:focus{
  --tw-ring-color: hsl(var(--brand));
}

.focus\\:ring-emerald-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 250 229 / var(--tw-ring-opacity));
}

.focus\\:ring-indigo-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(199 210 254 / var(--tw-ring-opacity));
}

.focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity));
}

.focus\\:ring-indigo-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(79 70 229 / var(--tw-ring-opacity));
}

.focus\\:ring-orange-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 115 22 / var(--tw-ring-opacity));
}

.focus\\:ring-primary:focus{
  --tw-ring-color: hsl(var(--primary));
}

.focus\\:ring-red-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity));
}

.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-violet-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(196 181 253 / var(--tw-ring-opacity));
}

.focus\\:ring-opacity-50:focus{
  --tw-ring-opacity: 0.5;
}

.focus\\:ring-offset-0:focus{
  --tw-ring-offset-width: 0px;
}

.focus\\:ring-offset-1:focus{
  --tw-ring-offset-width: 1px;
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:bg-border:focus-visible{
  background-color: hsl(var(--border));
}

.focus-visible\\:stroke-\\[color\\:var\\(--text-primary\\)\\]:focus-visible{
  stroke: var(--text-primary);
}

.focus-visible\\:underline:focus-visible{
  text-decoration-line: underline;
}

.focus-visible\\:opacity-100:focus-visible{
  opacity: 1;
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:outline:focus-visible{
  outline-style: solid;
}

.focus-visible\\:outline-2:focus-visible{
  outline-width: 2px;
}

.focus-visible\\:outline-ring:focus-visible{
  outline-color: hsl(var(--ring));
}

.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-inset:focus-visible{
  --tw-ring-inset: inset;
}

.focus-visible\\:ring-blue-300:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity));
}

.focus-visible\\:ring-destructive\\/30:focus-visible{
  --tw-ring-color: hsl(var(--destructive) / 0.3);
}

.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-rose-300:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 164 175 / var(--tw-ring-opacity));
}

.focus-visible\\:ring-slate-300:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(203 213 225 / var(--tw-ring-opacity));
}

.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}

.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}

.focus-visible\\:\\[fill-opacity\\:0\\.6\\]:focus-visible{
  fill-opacity: 0.6;
}

.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:bg-border-strong:active{
  background-color: hsl(var(--border-strong));
}

.active\\:bg-slate-200:active{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}

.disabled\\:cursor-default:disabled{
  cursor: default;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:bg-gray-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.disabled\\:bg-gray-400:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}

.disabled\\:bg-gray-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}

.disabled\\:bg-primary:disabled{
  background-color: hsl(var(--primary));
}

.disabled\\:text-gray-400:disabled{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

.disabled\\:text-gray-600:disabled{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}

.disabled\\:text-muted-foreground:disabled{
  color: hsl(var(--muted-foreground));
}

.disabled\\:text-slate-300:disabled{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity));
}

.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}

.group\\/record[open] .group-open\\/record\\:rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:block{
  display: block;
}

.group:hover .group-hover\\:flex{
  display: flex;
}

.group:hover .group-hover\\:hidden{
  display: none;
}

.group:hover .group-hover\\:scale-125{
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-opacity-50{
  --tw-bg-opacity: 0.5;
}

.group\\/row:hover .group-hover\\/row\\:text-foreground{
  color: hsl(var(--foreground));
}

.group:hover .group-hover\\:text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:text-brand{
  color: hsl(var(--brand));
}

.group:hover .group-hover\\:text-foreground\\/80{
  color: hsl(var(--foreground) / 0.8);
}

.group:hover .group-hover\\:text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:text-primary{
  color: hsl(var(--primary));
}

.group:hover .group-hover\\:text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}

.group\\/row:hover .group-hover\\/row\\:underline{
  text-decoration-line: underline;
}

.group\\/cell:hover .group-hover\\/cell\\:opacity-100{
  opacity: 1;
}

.group\\/row:hover .group-hover\\/row\\:opacity-100{
  opacity: 1;
}

.group\\/section:hover .group-hover\\/section\\:opacity-100{
  opacity: 1;
}

.group\\/visual:hover .group-hover\\/visual\\:opacity-100{
  opacity: 1;
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group:hover .group-hover\\:opacity-80{
  opacity: 0.8;
}

.group:focus-visible .group-focus-visible\\:scale-125{
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:focus-visible .group-focus-visible\\:opacity-100{
  opacity: 1;
}

.peer:checked ~ .peer-checked\\:bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:after\\:translate-x-full::after{
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:checked ~ .peer-checked\\:after\\:border-white::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.peer:focus ~ .peer-focus\\:ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.peer:focus ~ .peer-focus\\:ring-indigo-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 180 252 / var(--tw-ring-opacity));
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-50{
  opacity: 0.5;
}

.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}

.has-\\[\\:disabled\\]\\:cursor-not-allowed:has(:disabled){
  cursor: not-allowed;
}

.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}

.aria-disabled\\:cursor-not-allowed[aria-disabled="true"]{
  cursor: not-allowed;
}

.aria-disabled\\:opacity-40[aria-disabled="true"]{
  opacity: 0.4;
}

.aria-disabled\\:opacity-50[aria-disabled="true"]{
  opacity: 0.5;
}

.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}

.data-\\[state\\=inactive\\]\\:hidden[data-state="inactive"]{
  display: none;
}

.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=checked\\]\\:translate-x-\\[var\\(--switch-travel\\)\\][data-state="checked"]{
  --tw-translate-x: var(--switch-travel);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes accordion-up{

  from{
    height: var(--radix-accordion-content-height);
  }

  to{
    height: 0;
  }
}

.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}

@keyframes accordion-down{

  from{
    height: 0;
  }

  to{
    height: var(--radix-accordion-content-height);
  }
}

.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}

.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}

.data-\\[state\\=active\\]\\:border-primary[data-state="active"]{
  border-color: hsl(var(--primary));
}

.data-\\[state\\=active\\]\\:border-slate-900[data-state="active"]{
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity));
}

.data-\\[state\\=checked\\]\\:border-destructive[data-state="checked"]{
  border-color: hsl(var(--destructive));
}

.data-\\[state\\=unchecked\\]\\:border-destructive[data-state="unchecked"]{
  border-color: hsl(var(--destructive));
}

.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}

.data-\\[state\\=active\\]\\:bg-transparent[data-state="active"]{
  background-color: transparent;
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}

.data-\\[state\\=unchecked\\]\\:bg-\\[var\\(--switch-track-unchecked\\)\\][data-state="unchecked"]{
  background-color: var(--switch-track-unchecked);
}

.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}

.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}

.data-\\[state\\=active\\]\\:text-slate-900[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity));
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}

.data-\\[state\\=inactive\\]\\:text-muted-foreground[data-state="inactive"]{
  color: hsl(var(--muted-foreground));
}

.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}

.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}

.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}

.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[state\\=active\\]\\:shadow-none[data-state="active"]{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}

.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}

.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@media (prefers-reduced-motion: no-preference){

  @keyframes pulse{

    50%{
      opacity: .5;
    }
  }

  .motion-safe\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .motion-safe\\:animate-in{
    animation-name: enter;
    animation-duration: 150ms;
    --tw-enter-opacity: initial;
    --tw-enter-scale: initial;
    --tw-enter-rotate: initial;
    --tw-enter-translate-x: initial;
    --tw-enter-translate-y: initial;
  }

  .motion-safe\\:fade-in{
    --tw-enter-opacity: 0;
  }

  .motion-safe\\:zoom-in-95{
    --tw-enter-scale: .95;
  }
}

@media (prefers-reduced-motion: reduce){

  .motion-reduce\\:animate-none{
    animation: none;
  }
}

.dark\\:block:is(.dark *){
  display: block;
}

.dark\\:hidden:is(.dark *){
  display: none;
}

.dark\\:divide-gray-700:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-divide-opacity));
}

.dark\\:divide-gray-800:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-divide-opacity));
}

.dark\\:border-amber-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity));
}

.dark\\:border-amber-900\\/30:is(.dark *){
  border-color: rgb(120 53 15 / 0.3);
}

.dark\\:border-blue-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity));
}

.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}

.dark\\:border-emerald-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / var(--tw-border-opacity));
}

.dark\\:border-gray-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}

.dark\\:border-gray-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}

.dark\\:border-gray-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity));
}

.dark\\:border-green-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / var(--tw-border-opacity));
}

.dark\\:border-indigo-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
}

.dark\\:border-indigo-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / var(--tw-border-opacity));
}

.dark\\:border-indigo-900\\/50:is(.dark *){
  border-color: rgb(49 46 129 / 0.5);
}

.dark\\:border-orange-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(154 52 18 / var(--tw-border-opacity));
}

.dark\\:border-purple-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(107 33 168 / var(--tw-border-opacity));
}

.dark\\:border-red-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}

.dark\\:border-red-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity));
}

.dark\\:border-red-900\\/30:is(.dark *){
  border-color: rgb(127 29 29 / 0.3);
}

.dark\\:border-red-900\\/50:is(.dark *){
  border-color: rgb(127 29 29 / 0.5);
}

.dark\\:border-zinc-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity));
}

.dark\\:bg-amber-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(120 53 15 / var(--tw-bg-opacity));
}

.dark\\:bg-amber-900\\/10:is(.dark *){
  background-color: rgb(120 53 15 / 0.1);
}

.dark\\:bg-amber-900\\/20:is(.dark *){
  background-color: rgb(120 53 15 / 0.2);
}

.dark\\:bg-amber-900\\/40:is(.dark *){
  background-color: rgb(120 53 15 / 0.4);
}

.dark\\:bg-blue-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity));
}

.dark\\:bg-blue-900\\/20:is(.dark *){
  background-color: rgb(30 58 138 / 0.2);
}

.dark\\:bg-blue-900\\/30:is(.dark *){
  background-color: rgb(30 58 138 / 0.3);
}

.dark\\:bg-emerald-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(6 78 59 / var(--tw-bg-opacity));
}

.dark\\:bg-emerald-900\\/40:is(.dark *){
  background-color: rgb(6 78 59 / 0.4);
}

.dark\\:bg-gray-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}

.dark\\:bg-gray-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

.dark\\:bg-gray-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}

.dark\\:bg-gray-800\\/50:is(.dark *){
  background-color: rgb(31 41 55 / 0.5);
}

.dark\\:bg-gray-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}

.dark\\:bg-gray-900\\/20:is(.dark *){
  background-color: rgb(17 24 39 / 0.2);
}

.dark\\:bg-gray-900\\/50:is(.dark *){
  background-color: rgb(17 24 39 / 0.5);
}

.dark\\:bg-gray-950:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity));
}

.dark\\:bg-green-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(20 83 45 / var(--tw-bg-opacity));
}

.dark\\:bg-green-900\\/20:is(.dark *){
  background-color: rgb(20 83 45 / 0.2);
}

.dark\\:bg-green-900\\/30:is(.dark *){
  background-color: rgb(20 83 45 / 0.3);
}

.dark\\:bg-green-950:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(5 46 22 / var(--tw-bg-opacity));
}

.dark\\:bg-indigo-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity));
}

.dark\\:bg-indigo-900\\/30:is(.dark *){
  background-color: rgb(49 46 129 / 0.3);
}

.dark\\:bg-orange-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(124 45 18 / var(--tw-bg-opacity));
}

.dark\\:bg-orange-900\\/40:is(.dark *){
  background-color: rgb(124 45 18 / 0.4);
}

.dark\\:bg-purple-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(88 28 135 / var(--tw-bg-opacity));
}

.dark\\:bg-purple-900\\/30:is(.dark *){
  background-color: rgb(88 28 135 / 0.3);
}

.dark\\:bg-red-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}

.dark\\:bg-red-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(127 29 29 / var(--tw-bg-opacity));
}

.dark\\:bg-red-900\\/10:is(.dark *){
  background-color: rgb(127 29 29 / 0.1);
}

.dark\\:bg-red-900\\/20:is(.dark *){
  background-color: rgb(127 29 29 / 0.2);
}

.dark\\:bg-red-900\\/40:is(.dark *){
  background-color: rgb(127 29 29 / 0.4);
}

.dark\\:bg-red-950:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(69 10 10 / var(--tw-bg-opacity));
}

.dark\\:bg-red-950\\/20:is(.dark *){
  background-color: rgb(69 10 10 / 0.2);
}

.dark\\:bg-sky-900\\/40:is(.dark *){
  background-color: rgb(12 74 110 / 0.4);
}

.dark\\:bg-white:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.dark\\:bg-yellow-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(113 63 18 / var(--tw-bg-opacity));
}

.dark\\:bg-yellow-900\\/20:is(.dark *){
  background-color: rgb(113 63 18 / 0.2);
}

.dark\\:bg-yellow-900\\/30:is(.dark *){
  background-color: rgb(113 63 18 / 0.3);
}

.dark\\:via-white\\/20:is(.dark *){
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:text-amber-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity));
}

.dark\\:text-amber-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity));
}

.dark\\:text-amber-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity));
}

.dark\\:text-blue-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity));
}

.dark\\:text-blue-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity));
}

.dark\\:text-blue-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity));
}

.dark\\:text-emerald-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity));
}

.dark\\:text-emerald-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity));
}

.dark\\:text-emerald-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}

.dark\\:text-gray-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}

.dark\\:text-gray-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}

.dark\\:text-gray-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}

.dark\\:text-gray-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

.dark\\:text-gray-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.dark\\:text-gray-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}

.dark\\:text-green-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(220 252 231 / var(--tw-text-opacity));
}

.dark\\:text-green-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity));
}

.dark\\:text-green-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity));
}

.dark\\:text-green-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity));
}

.dark\\:text-indigo-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity));
}

.dark\\:text-indigo-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity));
}

.dark\\:text-orange-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(254 215 170 / var(--tw-text-opacity));
}

.dark\\:text-orange-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity));
}

.dark\\:text-orange-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity));
}

.dark\\:text-purple-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity));
}

.dark\\:text-red-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity));
}

.dark\\:text-red-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}

.dark\\:text-red-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}

.dark\\:text-sky-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(186 230 253 / var(--tw-text-opacity));
}

.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark\\:text-yellow-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity));
}

.dark\\:text-yellow-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity));
}

.dark\\:text-yellow-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity));
}

.dark\\:text-zinc-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / var(--tw-text-opacity));
}

.dark\\:text-zinc-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity));
}

.dark\\:text-zinc-50:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity));
}

.dark\\:ring-white\\/15:is(.dark *){
  --tw-ring-color: rgb(255 255 255 / 0.15);
}

.dark\\:invert:is(.dark *){
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.dark\\:hover\\:border-blue-600:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
}

.dark\\:hover\\:border-blue-700:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity));
}

.dark\\:hover\\:bg-blue-900\\/30:hover:is(.dark *){
  background-color: rgb(30 58 138 / 0.3);
}

.dark\\:hover\\:bg-gray-500:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-gray-600:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-gray-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-gray-700\\/50:hover:is(.dark *){
  background-color: rgb(55 65 81 / 0.5);
}

.dark\\:hover\\:bg-gray-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-gray-900:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-indigo-600:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-red-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-red-900\\/20:hover:is(.dark *){
  background-color: rgb(127 29 29 / 0.2);
}

.dark\\:hover\\:bg-red-900\\/30:hover:is(.dark *){
  background-color: rgb(127 29 29 / 0.3);
}

.dark\\:hover\\:text-blue-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity));
}

.dark\\:hover\\:text-gray-200:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}

.dark\\:hover\\:text-gray-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}

.dark\\:hover\\:text-indigo-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity));
}

.dark\\:hover\\:text-red-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}

.dark\\:hover\\:text-red-400:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}

.dark\\:hover\\:text-zinc-200:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / var(--tw-text-opacity));
}

.dark\\:focus\\:ring-indigo-500:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity));
}

.dark\\:disabled\\:bg-gray-600:disabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}

@media not all and (min-width: 768px){

  .max-md\\:max-h-none{
    max-height: none;
  }

  .max-md\\:w-\\[var\\(--component-sidebar-collapsed-width\\)\\]{
    width: var(--component-sidebar-collapsed-width);
  }
}

@media (min-width: 640px){

  .sm\\:top-\\[var\\(--component-command-top-desktop\\)\\]{
    top: var(--component-command-top-desktop);
  }

  .sm\\:order-none{
    order: 0;
  }

  .sm\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:col-start-4{
    grid-column-start: 4;
  }

  .sm\\:col-start-auto{
    grid-column-start: auto;
  }

  .sm\\:row-start-auto{
    grid-row-start: auto;
  }

  .sm\\:-mx-5{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .sm\\:-mx-6{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .sm\\:mx-16{
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .sm\\:-mb-4{
    margin-bottom: -1rem;
  }

  .sm\\:ml-auto{
    margin-left: auto;
  }

  .sm\\:mr-0{
    margin-right: 0px;
  }

  .sm\\:mr-\\[18px\\]{
    margin-right: 18px;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:mt-6{
    margin-top: 1.5rem;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:inline-flex{
    display: inline-flex;
  }

  .sm\\:grid{
    display: grid;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:w-44{
    width: 11rem;
  }

  .sm\\:w-48{
    width: 12rem;
  }

  .sm\\:w-52{
    width: 13rem;
  }

  .sm\\:w-56{
    width: 14rem;
  }

  .sm\\:w-64{
    width: 16rem;
  }

  .sm\\:w-80{
    width: 20rem;
  }

  .sm\\:w-\\[34rem\\]{
    width: 34rem;
  }

  .sm\\:w-\\[480px\\]{
    width: 480px;
  }

  .sm\\:w-\\[580px\\]{
    width: 580px;
  }

  .sm\\:w-\\[600px\\]{
    width: 600px;
  }

  .sm\\:w-\\[640px\\]{
    width: 640px;
  }

  .sm\\:w-\\[70vw\\]{
    width: 70vw;
  }

  .sm\\:w-\\[calc\\(100\\%-var\\(--space-2\\)\\)\\]{
    width: calc(100% - var(--space-2));
  }

  .sm\\:w-\\[var\\(--component-search-trigger-width\\)\\]{
    width: var(--component-search-trigger-width);
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:min-w-\\[400px\\]{
    min-width: 400px;
  }

  .sm\\:\\!max-w-md{
    max-width: 28rem !important;
  }

  .sm\\:max-w-2xl{
    max-width: 42rem;
  }

  .sm\\:max-w-4xl{
    max-width: 56rem;
  }

  .sm\\:max-w-5xl{
    max-width: 64rem;
  }

  .sm\\:max-w-\\[500px\\]{
    max-width: 500px;
  }

  .sm\\:max-w-\\[600px\\]{
    max-width: 600px;
  }

  .sm\\:max-w-lg{
    max-width: 32rem;
  }

  .sm\\:max-w-md{
    max-width: 28rem;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:max-w-xl{
    max-width: 36rem;
  }

  .sm\\:flex-initial{
    flex: 0 1 auto;
  }

  .sm\\:shrink-0{
    flex-shrink: 0;
  }

  .sm\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[10rem_1fr_auto\\]{
    grid-template-columns: 10rem 1fr auto;
  }

  .sm\\:grid-cols-\\[18rem_13rem_1fr_13rem\\]{
    grid-template-columns: 18rem 13rem 1fr 13rem;
  }

  .sm\\:grid-cols-\\[190px_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 190px minmax(0,1fr);
  }

  .sm\\:grid-cols-\\[var\\(--component-job-state-column\\)_minmax\\(0\\2c 1fr\\)_var\\(--component-job-target-column\\)_var\\(--component-job-percent-column\\)\\]{
    grid-template-columns: var(--component-job-state-column) minmax(0,1fr) var(--component-job-target-column) var(--component-job-percent-column);
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }

  .sm\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:items-end{
    align-items: flex-end;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-0{
    gap: 0px;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-6{
    gap: 1.5rem;
  }

  .sm\\:gap-y-0{
    row-gap: 0px;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .sm\\:divide-x > :not([hidden]) ~ :not([hidden]){
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  }

  .sm\\:divide-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }

  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }

  .sm\\:border-l{
    border-left-width: 1px;
  }

  .sm\\:border-l-0{
    border-left-width: 0px;
  }

  .sm\\:border-r{
    border-right-width: 1px;
  }

  .sm\\:border-r-0{
    border-right-width: 0px;
  }

  .sm\\:border-t{
    border-top-width: 1px;
  }

  .sm\\:border-t-0{
    border-top-width: 0px;
  }

  .sm\\:border-border{
    border-color: hsl(var(--border));
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-9{
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .sm\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:pl-0{
    padding-left: 0px;
  }

  .sm\\:pl-\\[var\\(--space-5\\)\\]{
    padding-left: var(--space-5);
  }

  .sm\\:pr-0{
    padding-right: 0px;
  }

  .sm\\:pr-10{
    padding-right: 2.5rem;
  }

  .sm\\:pr-\\[18px\\]{
    padding-right: 18px;
  }

  .sm\\:pr-\\[var\\(--space-5\\)\\]{
    padding-right: var(--space-5);
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}

@media (min-width: 768px){

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:block{
    display: block;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:inline-flex{
    display: inline-flex;
  }

  .md\\:h-full{
    height: 100%;
  }

  .md\\:max-h-none{
    max-height: none;
  }

  .md\\:min-h-0{
    min-height: 0px;
  }

  .md\\:w-64{
    width: 16rem;
  }

  .md\\:w-\\[var\\(--component-outline-width\\)\\]{
    width: var(--component-outline-width);
  }

  .md\\:w-\\[var\\(--component-sidebar-collapsed-width\\)\\]{
    width: var(--component-sidebar-collapsed-width);
  }

  .md\\:w-\\[var\\(--component-sidebar-width\\)\\]{
    width: var(--component-sidebar-width);
  }

  .md\\:max-w-\\[100\\%\\]{
    max-width: 100%;
  }

  .md\\:shrink-0{
    flex-shrink: 0;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[230px_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 230px minmax(0,1fr);
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1\\.35fr\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(0,1.35fr) minmax(0,1fr);
  }

  .md\\:grid-cols-\\[minmax\\(var\\(--component-master-list-min-width\\)\\2c 0\\.4fr\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(var(--component-master-list-min-width),0.4fr) minmax(0,1fr);
  }

  .md\\:grid-cols-\\[var\\(--component-audit-summary-width\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: var(--component-audit-summary-width) minmax(0,1fr);
  }

  .md\\:grid-cols-\\[var\\(--component-outline-width\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: var(--component-outline-width) minmax(0,1fr);
  }

  .md\\:grid-cols-\\[var\\(--component-verdict-width\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: var(--component-verdict-width) minmax(0,1fr);
  }

  .md\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-start{
    align-items: flex-start;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:border-b-0{
    border-bottom-width: 0px;
  }

  .md\\:border-l{
    border-left-width: 1px;
  }

  .md\\:border-r{
    border-right-width: 1px;
  }

  .md\\:border-t-0{
    border-top-width: 0px;
  }

  .md\\:px-\\[var\\(--component-page-padding-x\\)\\]{
    padding-left: var(--component-page-padding-x);
    padding-right: var(--component-page-padding-x);
  }

  .md\\:px-\\[var\\(--space-4\\)\\]{
    padding-left: var(--space-4);
    padding-right: var(--space-4);
  }

  .md\\:pb-\\[var\\(--component-page-padding-bottom\\)\\]{
    padding-bottom: var(--component-page-padding-bottom);
  }

  .md\\:pt-0{
    padding-top: 0px;
  }

  .md\\:pt-\\[var\\(--component-page-padding-top\\)\\]{
    padding-top: var(--component-page-padding-top);
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 1024px){

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .lg\\:col-start-1{
    grid-column-start: 1;
  }

  .lg\\:col-start-2{
    grid-column-start: 2;
  }

  .lg\\:row-span-2{
    grid-row: span 2 / span 2;
  }

  .lg\\:row-start-1{
    grid-row-start: 1;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:h-full{
    height: 100%;
  }

  .lg\\:w-64{
    width: 16rem;
  }

  .lg\\:w-\\[324px\\]{
    width: 324px;
  }

  .lg\\:w-\\[60vw\\]{
    width: 60vw;
  }

  .lg\\:w-\\[var\\(--component-briefing-rail-width\\)\\]{
    width: var(--component-briefing-rail-width);
  }

  .lg\\:grid-cols-10{
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .lg\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .lg\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .lg\\:grid-cols-9{
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 2fr\\)\\]{
    grid-template-columns: minmax(0,1fr) minmax(0,2fr);
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_var\\(--component-briefing-rail-width\\)\\]{
    grid-template-columns: minmax(0,1fr) var(--component-briefing-rail-width);
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_var\\(--component-detail-aside-width\\)\\]{
    grid-template-columns: minmax(0,1fr) var(--component-detail-aside-width);
  }

  .lg\\:grid-cols-\\[var\\(--component-risk-matrix-width\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: var(--component-risk-matrix-width) minmax(0,1fr);
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .lg\\:self-start{
    align-self: flex-start;
  }

  .lg\\:overflow-auto{
    overflow: auto;
  }

  .lg\\:overflow-hidden{
    overflow: hidden;
  }

  .lg\\:rounded-\\[var\\(--radius-rail\\)\\]{
    border-radius: var(--radius-rail);
  }

  .lg\\:rounded-bl-\\[var\\(--radius-rail\\)\\]{
    border-bottom-left-radius: var(--radius-rail);
  }

  .lg\\:border-l{
    border-left-width: 1px;
  }

  .lg\\:border-l-0{
    border-left-width: 0px;
  }

  .lg\\:border-t{
    border-top-width: 1px;
  }

  .lg\\:border-t-0{
    border-top-width: 0px;
  }

  .lg\\:p-10{
    padding: 2.5rem;
  }

  .lg\\:p-8{
    padding: 2rem;
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:pl-0{
    padding-left: 0px;
  }

  .lg\\:pl-\\[var\\(--space-5\\)\\]{
    padding-left: var(--space-5);
  }

  .lg\\:pr-0{
    padding-right: 0px;
  }

  .lg\\:pr-\\[var\\(--space-5\\)\\]{
    padding-right: var(--space-5);
  }
}

@media (min-width: 1280px){

  .xl\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .xl\\:block{
    display: block;
  }

  .xl\\:flex{
    display: flex;
  }

  .xl\\:h-full{
    height: 100%;
  }

  .xl\\:max-h-none{
    max-height: none;
  }

  .xl\\:min-h-0{
    min-height: 0px;
  }

  .xl\\:w-80{
    width: 20rem;
  }

  .xl\\:w-\\[var\\(--component-assist-panel-width\\)\\]{
    width: var(--component-assist-panel-width);
  }

  .xl\\:w-full{
    width: 100%;
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_var\\(--component-editor-side-width\\)\\]{
    grid-template-columns: minmax(0,1fr) var(--component-editor-side-width);
  }

  .xl\\:grid-cols-\\[var\\(--component-outline-width\\)_minmax\\(0\\2c 1fr\\)_var\\(--component-editor-side-width\\)\\]{
    grid-template-columns: var(--component-outline-width) minmax(0,1fr) var(--component-editor-side-width);
  }

  .xl\\:flex-row{
    flex-direction: row;
  }

  .xl\\:border-l{
    border-left-width: 1px;
  }

  .xl\\:border-t-0{
    border-top-width: 0px;
  }
}

@media (min-width: 1536px){

  .\\32xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media print{

  .print\\:hidden{
    display: none;
  }

  .print\\:opacity-100{
    opacity: 1;
  }

  .print\\:\\[stroke-opacity\\:0\\.55\\]{
    stroke-opacity: 0.55;
  }
}

@media (min-width: 768px){

  .md\\:\\[\\&\\+\\&\\]\\:border-l+.md\\:\\[\\&\\+\\&\\]\\:border-l{
    border-left-width: 1px;
  }

  .md\\:\\[\\&\\+\\&\\]\\:border-border+.md\\:\\[\\&\\+\\&\\]\\:border-border{
    border-color: hsl(var(--border));
  }
}

.\\[\\&\\:\\:-webkit-details-marker\\]\\:hidden::-webkit-details-marker{
  display: none;
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}

.\\[\\&\\>\\*\\]\\:my-0>*{
  margin-top: 0px;
  margin-bottom: 0px;
}

.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>div\\:last-child\\]\\:min-w-0>div:last-child{
  min-width: 0px;
}

.\\[\\&\\>div\\:last-child\\]\\:max-w-full>div:last-child{
  max-width: 100%;
}

.\\[\\&\\>div\\:last-child\\]\\:shrink>div:last-child{
  flex-shrink: 1;
}

.\\[\\&\\>div\\]\\:h-full>div{
  height: 100%;
}

.\\[\\&\\>div\\]\\:bg-blue-500>div{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}

.\\[\\&\\>div\\]\\:bg-destructive>div{
  background-color: hsl(var(--destructive));
}

.\\[\\&\\>div\\]\\:bg-emerald-500>div{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}

.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.\\[\\&\\>span\\]\\:whitespace-normal>span{
  white-space: normal;
}

.\\[\\&\\>span\\]\\:break-words>span{
  overflow-wrap: break-word;
}

.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>svg\\:last-child\\]\\:hidden>svg:last-child{
  display: none;
}

.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}

.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}

.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}

.\\[\\&\\>svg\\]\\:h-12>svg{
  height: 3rem;
}

.\\[\\&\\>svg\\]\\:h-2\\.5>svg{
  height: 0.625rem;
}

.\\[\\&\\>svg\\]\\:h-3>svg{
  height: 0.75rem;
}

.\\[\\&\\>svg\\]\\:h-8>svg{
  height: 2rem;
}

.\\[\\&\\>svg\\]\\:w-12>svg{
  width: 3rem;
}

.\\[\\&\\>svg\\]\\:w-2\\.5>svg{
  width: 0.625rem;
}

.\\[\\&\\>svg\\]\\:w-3>svg{
  width: 0.75rem;
}

.\\[\\&\\>svg\\]\\:w-8>svg{
  width: 2rem;
}

.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}

.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}

.\\[\\&\\>svg\\]\\:text-muted-foreground>svg{
  color: hsl(var(--muted-foreground));
}

.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}

.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\[hidden\\]\\]\\:hidden[hidden]{
  display: none;
}

.\\[\\&_\\.ht-grid\\]\\:h-full .ht-grid{
  height: 100%;
}

.\\[\\&_\\.ht-root-wrapper\\]\\:h-full .ht-root-wrapper{
  height: 100%;
}

.\\[\\&_\\.recharts-cartesian-axis-tick_text\\]\\:fill-muted-foreground .recharts-cartesian-axis-tick text{
  fill: hsl(var(--muted-foreground));
}

.\\[\\&_\\.recharts-cartesian-grid_line\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border\\/50 .recharts-cartesian-grid line[stroke='#ccc']{
  stroke: hsl(var(--border) / 0.5);
}

.\\[\\&_\\.recharts-curve\\.recharts-tooltip-cursor\\]\\:stroke-border .recharts-curve.recharts-tooltip-cursor{
  stroke: hsl(var(--border));
}

.\\[\\&_\\.recharts-dot\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-dot[stroke='#fff']{
  stroke: transparent;
}

.\\[\\&_\\.recharts-layer\\]\\:outline-none .recharts-layer{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.\\[\\&_\\.recharts-polar-grid_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-polar-grid [stroke='#ccc']{
  stroke: hsl(var(--border));
}

.\\[\\&_\\.recharts-radial-bar-background-sector\\]\\:fill-muted .recharts-radial-bar-background-sector{
  fill: hsl(var(--muted));
}

.\\[\\&_\\.recharts-rectangle\\.recharts-tooltip-cursor\\]\\:fill-muted .recharts-rectangle.recharts-tooltip-cursor{
  fill: hsl(var(--muted));
}

.\\[\\&_\\.recharts-reference-line_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-reference-line [stroke='#ccc']{
  stroke: hsl(var(--border));
}

.\\[\\&_\\.recharts-sector\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-sector[stroke='#fff']{
  stroke: transparent;
}

.\\[\\&_\\.recharts-sector\\]\\:outline-none .recharts-sector{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.\\[\\&_\\.recharts-surface\\]\\:outline-none .recharts-surface{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}

.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}

.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]\\]\\:pr-\\[var\\(--space-10\\)\\] [cmdk-input-wrapper]{
  padding-right: var(--space-10);
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}

.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}

.\\[\\&_iframe\\]\\:size-full iframe{
  width: 100%;
  height: 100%;
}

.\\[\\&_iframe\\]\\:border-0 iframe{
  border-width: 0px;
}

.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}

.\\[\\&_select\\]\\:\\!w-full select{
  width: 100% !important;
}

.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}

.\\[\\&_svg\\]\\:size-3 svg{
  width: 0.75rem;
  height: 0.75rem;
}

.\\[\\&_svg\\]\\:size-3\\.5 svg{
  width: 0.875rem;
  height: 0.875rem;
}

.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\]\\:size-5 svg{
  width: 1.25rem;
  height: 1.25rem;
}

.\\[\\&_svg\\]\\:size-\\[var\\(--icon-size-ui\\)\\] svg{
  width: var(--icon-size-ui);
  height: var(--icon-size-ui);
}

.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}

.\\[\\&_td\\]\\:py-\\[var\\(--space-1\\)\\] td{
  padding-top: var(--space-1);
  padding-bottom: var(--space-1);
}

.\\[\\&_thead_th\\]\\:sticky thead th{
  position: sticky;
}

.\\[\\&_thead_th\\]\\:top-0 thead th{
  top: 0px;
}

.\\[\\&_thead_th\\]\\:z-10 thead th{
  z-index: 10;
}

.\\[\\&_thead_th\\]\\:bg-background thead th{
  background-color: hsl(var(--background));
}

.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}

.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}

.\\[\\&_tr\\]\\:border-\\[var\\(--border-strong\\)\\] tr{
  border-color: var(--border-strong);
}
`, "",{"version":3,"sources":["webpack://./src/globals.css"],"names":[],"mappings":"AAIA;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,mDAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;IAAA,qBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,qBAAc;IAAd,8BAAc;IAAd,oCAAc;IAAd,+BAAc;IAAd,sCAAc;IAAd,gCAAc;IAAd,yCAAc;IAAd,6BAAc;IAAd,iCAAc;IAAd,oDAAc;IAAd,8BAAc;IAAd,8BAAc;IAAd,4BAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,6BAAc;IAAd,6EAAc;IAAd,iDAAc;IAAd,iDAAc;IAAd,kDAAc;IAAd,kDAAc;IAAd,+CAAc;IAAd,+CAAc;IAAd,8CAAc;IAAd,8CAAc;IAAd,+CAAc;IAAd,+CAAc;IAAd,+CAAc;IAAd,+CAAc;;IAAd,wBAAc;IAAd,oCAAc;IAAd,6CAAc;IAAd,mCAAc;IAAd,4CAAc;EAAA;;AAAd;IAAA,sBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,kCAAc;IAAd,oCAAc;IAAd,kCAAc;IAAd,uCAAc;IAAd,gCAAc;IAAd,2CAAc;IAAd,gCAAc;IAAd,iCAAc;;IAAd,4EAAc;IAAd,8BAAc;IAAd,8BAAc;IAAd,4BAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,6BAAc;IAAd,6EAAc;IAAd,iDAAc;IAAd,iDAAc;IAAd,kDAAc;IAAd,kDAAc;IAAd,+CAAc;IAAd,+CAAc;IAAd,8CAAc;IAAd,8CAAc;IAAd,gDAAc;IAAd,gDAAc;IAAd,iDAAc;IAAd,iDAAc;;IAAd,gDAAc;IAAd,oCAAc;IAAd,6CAAc;IAAd,mCAAc;IAAd,4CAAc;EAAA;;AAAd;EAAA;AAAc;;AAAd;;;;4DAAc;;AAAd;;IAAA,2BAAc;EAAA;;AAAd;EAAA,wCAAc;EAAd,6BAAc;EAAd,6BAAc;EAAd,mCAAc;EAAd;AAAc;;AAAd;;;;;;IAAA,gCAAc;IAAd,iCAAc;EAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA,sBAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,+BAAmB;OAAnB;AAAmB;AAAnB;EAAA,+BAAmB;OAAnB;AAAmB;AAAnB;EAAA,kCAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2EAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAGjB;IACE;;;;;KAKC;IACD,0BAA0B;IAC1B,qBAAqB;IACrB,6BAA6B;IAC7B,kBAAkB;IAClB,sDAAsD;EACxD;AAEA;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,2BAA2B;IAC7B;EACF;AAEA;IACE;MACE,eAAe;MACf,gBAAgB;MAChB,mCAAmC;IACrC;EACF;AAEA;IACE,kBAAkB;EACpB;AAEA,uCAAuC;AACvC;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,wBAAwB;IAC1B;EACF;AAMA,+BAA+B;AAC/B;IACE,qBAAqB;IACrB,+CAA+C;EACjD;AAEA;IACE,UAAU;IACV,WAAW;EACb;AAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AAEA;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;AAEA;IACE,8CAA8C;EAChD;AA3EF;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAmMnB,4DAA4D;AAC5D;EACE,yCAAyC;EACzC,eAAiB;EACjB,6BAA6B;;EAE7B,iBAAiB;EAEf;IAAA,8BAAmB;IAAnB;EAAmB;;EAGrB,gBAAgB;EAEd;IAAA;EAA4B;EAD9B;IAEE,+BAA+B;IAC/B,WAAW;IACX,SAAS;IACT,oBAAoB;EACtB;;EAEA,sEAAsE;EAEpE;IAAA;EAA8C;EAA9C;IAAA;EAA8C;EAA9C;IAAA,iBAA8C;IAA9C;EAA8C;EAA9C;IAAA;EAA8C;EAA9C;IAAA;EAA8C;EADhD;IAEE,6BAA6B;EAC/B;;EAGE;IAAA;EAAiD;;EAAjD;IAAA;EAAiD;;EAAjD;IAAA,kBAAiD;IAAjD;EAAiD;;EAAjD;IAAA;EAAiD;;EAAjD;IAAA;EAAiD;;EADnD;IAEE,6BAA6B;EAC/B;;EAGE;IAAA;EAAiD;;EAAjD;IAAA;EAAiD;;EAAjD;IAAA,mBAAiD;IAAjD;EAAiD;;EAAjD;IAAA;EAAiD;;EAAjD;IAAA;EAAiD;;EADnD;IAEE,6BAA6B;EAC/B;;EAGE;IAAA;EAAmD;;EAAnD;IAAA;EAAmD;;EAAnD;IAAA,eAAmD;IAAnD;EAAmD;;EAAnD;IAAA;EAAmD;;EAAnD;IAAA;EAAmD;;EADrD;IAEE,6BAA6B;EAC/B;;EAGE;IAAA;EAAiD;;EAAjD;IAAA;EAAiD;;EAAjD;IAAA,mBAAiD;IAAjD;EAAiD;;EAAjD;IAAA;EAAiD;;EAAjD;IAAA;EAAiD;;EADnD;IAEE,6BAA6B;EAC/B;;EAGE;IAAA;EAAiD;;EAAjD;IAAA;EAAiD;;EAAjD;IAAA,kBAAiD;IAAjD;EAAiD;;EAAjD;IAAA;EAAiD;;EAAjD;IAAA;EAAiD;;EADnD;IAEE,6BAA6B;EAC/B;;EAEA,eAAe;EAEb;IAAA;EAA2C;EAA3C;IAAA;EAA2C;EAA3C;IAAA;EAA2C;EAA3C;IAAA;EAA2C;EAD7C;IAEE,6BAA6B;EAC/B;;EAEA,4BAA4B;EAE1B;IAAA,kBAAsD;IAAtD;EAAsD;EAAtD;IAAA;EAAsD;EAAtD;IAAA;EAAsD;EAAtD;IAAA;EAAsD;EAAtD;IAAA;EAAsD;EAAtD;IAAA,uBAAsD;IAAtD,+DAAsD;IAAtD;EAAsD;;EAItD;IAAA,kBAAyD;IAAzD;EAAyD;;EAAzD;IAAA;EAAyD;;EAAzD;IAAA;EAAyD;;EAAzD;IAAA;EAAyD;;EAAzD;IAAA;EAAyD;;EAAzD;IAAA,uBAAyD;IAAzD,+DAAyD;IAAzD;EAAyD;;EAIzD;IAAA,oBAAuB;IAAvB;EAAuB;;EAAvB;IAAA;EAAuB;;EADzB;IAEE,6BAA6B;EAC/B;;EAEA,iBAAiB;EAGf;;IAAA;EAAgB;EAAhB;;IAAA;EAAgB;;EAGlB,oCAAoC;EAElC;IAAA,gBAA+E;IAA/E;EAA+E;EAA/E;IAAA,gCAA+E;IAA/E;EAA+E;EAA/E;IAAA;EAA+E;EAA/E;IAAA;EAA+E;EAA/E;IAAA;EAA+E;EAA/E;IAAA,mBAA+E;IAA/E;EAA+E;EAA/E;IAAA;EAA+E;EAA/E;IAAA;EAA+E;EADjF;IAEE,mCAAmC;EACrC;;EAEA,8DAA8D;EAE5D;IAAA,gBAAkC;IAAlC;EAAkC;EAAlC;IAAA;EAAkC;EAAlC;IAAA;EAAkC;;EAGpC,2DAA2D;EAEzD;IAAA;EAA6D;EAA7D;IAAA;EAA6D;EAA7D;IAAA;EAA6D;EAA7D;IAAA;EAA6D;EAA7D;IAAA;EAA6D;;EAG/D,4BAA4B;EAE1B;IAAA;EAAe;;EAGjB;IACE,uBAAuB;EACzB;;EAIE;;IAAA;EAA6B;;EAA7B;;IAAA;EAA6B;;EAF/B;;IAGE,uCAAuC;EACzC;;EAEA,8CAA8C;EAG5C;;IAAA;EAAkB;;EAGpB,6DAA6D;EAG3D;;IAAA;EAAsE;EAAtE;;IAAA;EAAsE;EAAtE;;IAAA;EAAsE;EAAtE;;IAAA,kBAAsE;IAAtE;EAAsE;EAAtE;;IAAA,mBAAsE;IAAtE;EAAsE;EAAtE;;IAAA;EAAsE;EAAtE;;IAAA;EAAsE;EAFxE;;IAGE,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA,8CAA8C;EAG5C;;IAAA;EAAqC;EAArC;;IAAA;EAAqC;EAArC;;IAAA,kBAAqC;IAArC;EAAqC;EAArC;;IAAA,mBAAqC;IAArC;EAAqC;EAFvC;;IAGE,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA,yBAAyB;EACzB;IACE,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,kBAAkB;EACpB;;EAEA,gBAAgB;EAEd;IAAA,gBAAsD;IAAtD;EAAsD;EAAtD;IAAA;EAAsD;EAAtD;IAAA;EAAsD;EAAtD;IAAA,kBAAsD;IAAtD;EAAsD;EAAtD;IAAA;EAAsD;;EAItD;IAAA;EAAwB;;EAAxB;IAAA,mBAAwB;IAAxB;EAAwB;;EAG1B,uCAAuC;EAOrC;;;;;;IAAA;EAAwF;EAAxF;;;;;;IAAA;EAAwF;EAAxF;;;;;;IAAA;EAAwF;EAAxF;;;;;;IAAA,oBAAwF;IAAxF;EAAwF;EAAxF;;;;;;IAAA,mBAAwF;IAAxF;EAAwF;EAAxF;;;;;;IAAA;EAAwF;EAAxF;;;;;;IAAA,mBAAwF;IAAxF;EAAwF;EAAxF;;;;;;IAAA;EAAwF;EAN1F;;;;;;IAOE,6BAA6B;EAC/B;;EAEA,UAAU;EAER;IAAA;EAAqD;EAArD;IAAA;EAAqD;EAArD;IAAA,+FAAqD;IAArD,wDAAqD;IAArD;EAAqD;EADvD;IAEE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA,wBAAwB;EAEtB;IAAA;EAAoB;EADtB;IAEE,6BAA6B;EAC/B;;EAGE;IAAA;EAAa;;EADf;IAEE,6BAA6B;EAC/B;;EAEA,oBAAoB;EAElB;IAAA,kBAAoB;IAApB;EAAoB;EAApB;IAAA;EAAoB;EADtB;IAEE,gCAAgC;EAClC;;EAEA,oBAAoB;EAElB;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAExB;;AAEA;yEACyE;AACzE;EACE,yCAAiC;UAAjC,iCAAiC;EACjC,0CAA0C;EAC1C,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,sCAAsC;AAEpC;EAAA;AAAa;;AAIb;EAAA,gBAA6B;EAA7B,oBAA6B;EAA7B,qBAA6B;EAA7B,oBAA6B;EAA7B;AAA6B;;AApa/B;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,mBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA,QAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,gBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA,QAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA,wBAsaA;EAtaA,wDAsaA;EAtaA;AAsaA;;AAtaA;EAAA,gBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,iDAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kDAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,8BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,0EAsaA;EAtaA,8FAsaA;EAtaA;AAsaA;;AAtaA;EAAA,+EAsaA;EAtaA,mGAsaA;EAtaA;AAsaA;;AAtaA;EAAA,6EAsaA;EAtaA,iGAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0CAsaA;EAtaA,uDAsaA;EAtaA;AAsaA;;AAtaA;EAAA,mCAsaA;EAtaA;AAsaA;;AAtaA;EAAA,gCAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,8BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,8BAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,iBAsaA;EAtaA,iBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,8BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,yBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,yBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sCAsaA;EAtaA;AAsaA;;AAtaA;EAAA,qBAsaA;EAtaA;AAsaA;;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;AAAA;;AAtaA;EAAA;AAsaA;;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;AAAA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,0EAsaA;EAtaA,8FAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA,8BAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,qBAsaA;EAtaA,yBAsaA;EAtaA,2BAsaA;EAtaA,yBAsaA;EAtaA,0BAsaA;EAtaA,+BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA,yBAsaA;EAtaA,0BAsaA;EAtaA,wBAsaA;EAtaA,yBAsaA;EAtaA,8BAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA,qBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,mBAsaA;EAtaA;AAsaA;;AAtaA;;EAAA;;IAAA;MAAA;IAsaA;EAAA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA,qBAsaA;IAtaA,yBAsaA;IAtaA,2BAsaA;IAtaA,yBAsaA;IAtaA,0BAsaA;IAtaA,+BAsaA;IAtaA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;AAAA;;AAtaA;;EAAA;IAAA;EAsaA;AAAA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sEAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,yBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;AAAA;;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA,qBAsaA;IAtaA;EAsaA;;EAtaA;IAAA,oBAsaA;IAtaA;EAsaA;;EAtaA;IAAA,iBAsaA;IAtaA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA,uBAsaA;IAtaA,sDAsaA;IAtaA;EAsaA;;EAtaA;IAAA,uBAsaA;IAtaA,oDAsaA;IAtaA;EAsaA;;EAtaA;IAAA,uBAsaA;IAtaA,2DAsaA;IAtaA;EAsaA;;EAtaA;IAAA,uBAsaA;IAtaA,+DAsaA;IAtaA;EAsaA;;EAtaA;IAAA,uBAsaA;IAtaA,8DAsaA;IAtaA;EAsaA;;EAtaA;IAAA,wBAsaA;IAtaA,0DAsaA;IAtaA;EAsaA;;EAtaA;IAAA,wBAsaA;IAtaA,kEAsaA;IAtaA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA,oBAsaA;IAtaA;EAsaA;;EAtaA;IAAA,kBAsaA;IAtaA;EAsaA;;EAtaA;IAAA,kBAsaA;IAtaA;EAsaA;;EAtaA;IAAA,qBAsaA;IAtaA;EAsaA;;EAtaA;IAAA,oBAsaA;IAtaA;EAsaA;;EAtaA;IAAA,qBAsaA;IAtaA;EAsaA;;EAtaA;IAAA,iBAsaA;IAtaA;EAsaA;;EAtaA;IAAA,iBAsaA;IAtaA;EAsaA;;EAtaA;IAAA,oBAsaA;IAtaA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA,iBAsaA;IAtaA;EAsaA;;EAtaA;IAAA,mBAsaA;IAtaA;EAsaA;AAAA;;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA,6CAsaA;IAtaA;EAsaA;;EAtaA;IAAA,4BAsaA;IAtaA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA,mBAsaA;IAtaA;EAsaA;AAAA;;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA,uBAsaA;IAtaA,2DAsaA;IAtaA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA,kBAsaA;IAtaA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;AAAA;;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;AAAA;;AAtaA;;EAAA;IAAA;EAsaA;AAAA;;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;AAAA;;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;AAAA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,eAsaA;EAtaA;AAsaA;;AAtaA;EAAA,qBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,gBAsaA;EAtaA,oBAsaA;EAtaA,4BAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,mBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,8BAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,8BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,8BAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,qBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,WAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,cAsaA;EAtaA;AAsaA;;AAtaA;EAAA,eAsaA;EAtaA;AAsaA;;AAtaA;EAAA,WAsaA;EAtaA;AAsaA;;AAtaA;EAAA,cAsaA;EAtaA;AAsaA;;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA,2BAsaA;EAtaA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA;;AAtaA;EAAA;AAsaA","sourcesContent":["@import \"@mono/ui-components/fonts.css\";\n@import \"@mono/ui-components/tokens.css\";\n@import \"@mono/ui-components/behaviors.css\";\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer utilities {\n  .chat-loading-glimmer {\n    background: linear-gradient(\n      100deg,\n      hsl(var(--muted-foreground)) 35%,\n      hsl(var(--foreground)) 50%,\n      hsl(var(--muted-foreground)) 65%\n    );\n    background-size: 250% 100%;\n    background-clip: text;\n    -webkit-background-clip: text;\n    color: transparent;\n    animation: chat-text-glimmer 2.8s ease-in-out infinite;\n  }\n\n  @keyframes chat-text-glimmer {\n    from {\n      background-position: 200% 0;\n    }\n    to {\n      background-position: -50% 0;\n    }\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    .chat-loading-glimmer {\n      animation: none;\n      background: none;\n      color: hsl(var(--muted-foreground));\n    }\n  }\n\n  .text-balance {\n    text-wrap: balance;\n  }\n\n  /* Workflow drawer slide-in animation */\n  @keyframes slide-in-right {\n    from {\n      transform: translateX(100%);\n    }\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  .animate-slide-in-right {\n    animation: slide-in-right 300ms ease-out;\n  }\n\n  /* Custom scrollbar utilities */\n  .scrollbar-thin {\n    scrollbar-width: thin;\n    scrollbar-color: hsl(var(--border)) transparent;\n  }\n\n  .scrollbar-thin::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n  }\n\n  .scrollbar-thin::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 3px;\n  }\n\n  .scrollbar-thin::-webkit-scrollbar-thumb {\n    background: hsl(var(--border));\n    border-radius: 3px;\n  }\n\n  .scrollbar-thin::-webkit-scrollbar-thumb:hover {\n    background: hsl(var(--muted-foreground) / 0.5);\n  }\n}\n\n@layer base {\n  :root {\n    --chart-1: 12 76% 61%;\n    --chart-2: 173 58% 39%;\n    --chart-3: 197 37% 24%;\n    --chart-4: 43 74% 66%;\n    --chart-5: 27 87% 67%;\n    --sidebar-background: 0 0% 98%;\n    --sidebar-foreground: 240 5.3% 26.1%;\n    --sidebar-primary: 240 5.9% 10%;\n    --sidebar-primary-foreground: 0 0% 98%;\n    --sidebar-accent: 240 4.8% 95.9%;\n    --sidebar-accent-foreground: 240 5.9% 10%;\n    --sidebar-border: 220 13% 91%;\n    --sidebar-ring: 217.2 91.2% 59.8%;\n    /* Block overlay colors for document visualization */\n    --block-color-heading: #3b82f6;\n    --block-color-content: #6b7280;\n    --block-color-table: #10b981;\n    --block-color-list: #f59e0b;\n    --block-color-image: #8b5cf6;\n    --block-color-footer: #ef4444;\n    /* Transparent variants for hover (20% opacity) and selection (40% opacity) */\n    --block-color-heading-20: rgba(59, 130, 246, 0.2);\n    --block-color-heading-40: rgba(59, 130, 246, 0.4);\n    --block-color-content-20: rgba(107, 114, 128, 0.2);\n    --block-color-content-40: rgba(107, 114, 128, 0.4);\n    --block-color-table-20: rgba(16, 185, 129, 0.2);\n    --block-color-table-40: rgba(16, 185, 129, 0.4);\n    --block-color-list-20: rgba(245, 158, 11, 0.2);\n    --block-color-list-40: rgba(245, 158, 11, 0.4);\n    --block-color-image-20: rgba(139, 92, 246, 0.2);\n    --block-color-image-40: rgba(139, 92, 246, 0.4);\n    --block-color-footer-20: rgba(239, 68, 68, 0.2);\n    --block-color-footer-40: rgba(239, 68, 68, 0.4);\n\n    /* Project type colors */\n    --project-type-proposal: 221 83% 53%;\n    --project-type-proposal-foreground: 0 0% 100%;\n    --project-type-general: 162 63% 41%;\n    --project-type-general-foreground: 0 0% 100%;\n  }\n\n  .dark {\n    --chart-1: 220 70% 50%;\n    --chart-2: 160 60% 45%;\n    --chart-3: 30 80% 55%;\n    --chart-4: 280 65% 60%;\n    --chart-5: 340 75% 55%;\n    --sidebar-background: 240 5.9% 10%;\n    --sidebar-foreground: 240 4.8% 95.9%;\n    --sidebar-primary: 224.3 76.3% 48%;\n    --sidebar-primary-foreground: 0 0% 100%;\n    --sidebar-accent: 240 3.7% 15.9%;\n    --sidebar-accent-foreground: 240 4.8% 95.9%;\n    --sidebar-border: 240 3.7% 15.9%;\n    --sidebar-ring: 217.2 91.2% 59.8%;\n\n    /* Block overlay colors for document visualization - lighter for dark mode */\n    --block-color-heading: #60a5fa;\n    --block-color-content: #9ca3af;\n    --block-color-table: #34d399;\n    --block-color-list: #fbbf24;\n    --block-color-image: #a78bfa;\n    --block-color-footer: #f87171;\n    /* Transparent variants for hover (20% opacity) and selection (40% opacity) */\n    --block-color-heading-20: rgba(96, 165, 250, 0.2);\n    --block-color-heading-40: rgba(96, 165, 250, 0.4);\n    --block-color-content-20: rgba(156, 163, 175, 0.2);\n    --block-color-content-40: rgba(156, 163, 175, 0.4);\n    --block-color-table-20: rgba(52, 211, 153, 0.2);\n    --block-color-table-40: rgba(52, 211, 153, 0.4);\n    --block-color-list-20: rgba(251, 191, 36, 0.2);\n    --block-color-list-40: rgba(251, 191, 36, 0.4);\n    --block-color-image-20: rgba(167, 139, 250, 0.2);\n    --block-color-image-40: rgba(167, 139, 250, 0.4);\n    --block-color-footer-20: rgba(248, 113, 113, 0.2);\n    --block-color-footer-40: rgba(248, 113, 113, 0.4);\n\n    /* Project type colors - lighter for dark mode */\n    --project-type-proposal: 217 91% 60%;\n    --project-type-proposal-foreground: 0 0% 100%;\n    --project-type-general: 160 84% 39%;\n    --project-type-general-foreground: 0 0% 100%;\n  }\n}\n\n@layer base {\n  * {\n    @apply border-border;\n  }\n\n  /* The shell is one fixed viewport and content scrolls inside it, so the\n     window itself never scrolls. Without this, a trackpad swipe over a part\n     that cannot scroll (or past the end of one that can) rubber-bands the\n     whole window on macOS and shows blank space under the app. Vertical\n     only: a sideways swipe stays back/forward navigation. */\n  html,\n  body {\n    overscroll-behavior-y: none;\n  }\n\n  body {\n    @apply bg-background text-foreground font-sans antialiased;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-family: var(--font-display);\n    letter-spacing: var(--ls-display);\n  }\n}\n\n/* TipTap Editor Styles - Match EnhancedMarkdown component */\n.tiptap {\n  /* Base prose styling with color scheme */\n  @apply max-w-none;\n  color: hsl(var(--foreground));\n\n  /* Focus styles */\n  &:focus {\n    @apply outline-none;\n  }\n\n  /* Placeholder */\n  p.is-editor-empty:first-child::before {\n    @apply text-muted-foreground;\n    content: attr(data-placeholder);\n    float: left;\n    height: 0;\n    pointer-events: none;\n  }\n\n  /* Headings - Match EnhancedMarkdown exactly with slate color scheme */\n  h1 {\n    @apply text-2xl font-bold mb-4 mt-6 first:mt-0;\n    color: hsl(var(--foreground));\n  }\n\n  h2 {\n    @apply text-xl font-semibold mb-3 mt-6 first:mt-0;\n    color: hsl(var(--foreground));\n  }\n\n  h3 {\n    @apply text-lg font-semibold mb-2 mt-4 first:mt-0;\n    color: hsl(var(--foreground));\n  }\n\n  h4 {\n    @apply text-base font-semibold mb-2 mt-3 first:mt-0;\n    color: hsl(var(--foreground));\n  }\n\n  h5 {\n    @apply text-sm font-semibold mb-2 mt-3 first:mt-0;\n    color: hsl(var(--foreground));\n  }\n\n  h6 {\n    @apply text-xs font-semibold mb-2 mt-3 first:mt-0;\n    color: hsl(var(--foreground));\n  }\n\n  /* Paragraphs */\n  p {\n    @apply leading-7 mb-4 last:mb-0 text-[15px];\n    color: hsl(var(--foreground));\n  }\n\n  /* Lists with proper color */\n  ul {\n    @apply list-disc list-outside ml-6 mb-4 space-y-1 my-2;\n  }\n\n  ol {\n    @apply list-decimal list-outside ml-6 mb-4 space-y-1 my-2;\n  }\n\n  li {\n    @apply leading-7 my-0.5;\n    color: hsl(var(--foreground));\n  }\n\n  /* Nested lists */\n  li > ul,\n  li > ol {\n    @apply mt-2 mb-2;\n  }\n\n  /* Blockquotes with proper styling */\n  blockquote {\n    @apply border-l-4 border-primary/50 pl-4 my-4 italic bg-muted/30 py-2 rounded-r;\n    color: hsl(var(--muted-foreground));\n  }\n\n  /* Tables with full styling - Match EnhancedMarkdown exactly */\n  table {\n    @apply w-full border-collapse my-4;\n  }\n\n  /* Wrap table in overflow container for horizontal scroll */\n  .editor-table {\n    @apply w-full border-collapse border border-border rounded-lg;\n  }\n\n  /* Table structure styling */\n  thead {\n    @apply bg-muted;\n  }\n\n  tbody {\n    background: transparent;\n  }\n\n  tr,\n  .editor-table-row {\n    @apply border-b border-border;\n    transition: background-color 0.15s ease;\n  }\n\n  /* Only hover on tbody rows, not header rows */\n  tbody tr:hover,\n  tbody .editor-table-row:hover {\n    @apply bg-muted/50;\n  }\n\n  /* Table header cells - gray background like inline preview */\n  th,\n  .editor-table-header {\n    @apply border border-border px-4 py-2 text-left font-semibold bg-muted;\n    color: hsl(var(--foreground));\n    position: relative;\n  }\n\n  /* Table data cells - transparent background */\n  td,\n  .editor-table-cell {\n    @apply border border-border px-4 py-2;\n    color: hsl(var(--foreground));\n    background: transparent;\n    position: relative;\n  }\n\n  /* Column resize handle */\n  .column-resize-handle {\n    position: absolute;\n    right: -2px;\n    top: 0;\n    bottom: 0;\n    width: 4px;\n    cursor: col-resize;\n    background-color: transparent;\n    z-index: 10;\n  }\n\n  .column-resize-handle:hover {\n    background-color: hsl(var(--primary) / 0.3);\n  }\n\n  .resize-cursor {\n    cursor: col-resize;\n  }\n\n  /* Code blocks */\n  pre {\n    @apply rounded-lg bg-zinc-950 p-4 my-4 overflow-x-auto;\n  }\n\n  code {\n    @apply font-mono text-sm;\n  }\n\n  /* Inline code with proper background */\n  p code,\n  li code,\n  h1 code,\n  h2 code,\n  h3 code,\n  h4 code {\n    @apply relative rounded bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold;\n    color: hsl(var(--foreground));\n  }\n\n  /* Links */\n  a {\n    @apply underline underline-offset-4 transition-colors;\n    color: hsl(var(--primary));\n  }\n\n  a:hover {\n    color: hsl(var(--primary) / 0.8);\n  }\n\n  /* Strong and emphasis */\n  strong {\n    @apply font-semibold;\n    color: hsl(var(--foreground));\n  }\n\n  em {\n    @apply italic;\n    color: hsl(var(--foreground));\n  }\n\n  /* Horizontal rule */\n  hr {\n    @apply my-6 border-t;\n    border-color: hsl(var(--border));\n  }\n\n  /* Selection color */\n  ::selection {\n    @apply bg-primary/20;\n  }\n}\n\n/* A figure in an answer that no source accounts for (lib/chat/figureHighlights).\n   Top level: the answer body is not inside the editor's .tiptap scope. */\n::highlight(specra-unverified) {\n  text-decoration: underline dotted;\n  text-decoration-color: hsl(var(--warning));\n  text-decoration-thickness: 2px;\n  text-underline-offset: 3px;\n}\n\n/* Editor wrapper for better spacing */\n.prose-editor-wrapper {\n  @apply w-full;\n}\n\n.prose-editor-wrapper .ProseMirror {\n  @apply min-h-[60vh] px-2 py-1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
